import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import CodeAssistWindow from "./CodeAssistWindow/CodeAssistWindow";
import CodeAssistStatus from "./CodeassistStatus/CodeAssistStatus";
import CodeHistory from "./CodeHistory/CodeHistory";
import {
  setCodeHistoryCard,
  setCodeAssistWindowCard,
  setCodeBookCard,
  setNudgingCard
} from "./redux/CodeAssistSlicer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setLocalStorageItem,
  calculateAge,
  calculateLOS,
  replaceEmptyWithNull,
  formatDate,
} from "../CodingScreen/utils";
// import CodeBook from "../CodeBook/CodeBook";
import PlusIcon from "../../common/assets/images/plus_icon.png";
import closeIcon from "../../common/assets/images/close-icon.png";
import documentationIcon from "../../common/assets/images/documentation.png";
import codeBookIcon from "../../common/assets/images/codebook-icon.png";
import gridImage from "../../common/assets/images/gridimg.png";
import undo_icon from "../../common/assets/images/undo.png";
import cloneDeep from "lodash/cloneDeep";
import {
  Grid,
  Tooltip,
  useTheme,
  useMediaQuery,
  Card,
  Box,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import LdsRoller from "../../utils/LdsRoller";
import { CodeContext } from "../pages/Coder/Coder";
import codinghistoryIcon from "../../common/assets/images/clock-rewind.png";
import codeassistIocn from "../../common/assets/images/settings-02.png";
import "./CodeAssistWrapper.css";
import { useLazyGetData2Query } from "../../store/apiSlice";
import EpisodeStatus from "../EpisodeStatus/EpisodeStatus";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import axios from "axios";
import CodeSearch from "./CodeSearch/CodeSearch";
import {
  fetchAllCodesbyStepFunction,
  fetchAllCodesProgress,
  fetchClusterWarnings,
  fetchDrgInformation,
  fetchDrgOptions,
  fetchEpisodes,
  fetchPrincipalDiagnosisCodes,
  getAuditorNamesAndQueues,
  getCoderNamesInActions,
  setClusterCodeWarningsWarningList,
  setcurrentClusterID,
  getunlockEpisode,
  resetSelectedMissingNotesOptions,
  setClusterCodeWarningsList,
  setShowMissningNotesDropdown,
  setEnableMissingNotes,
  setDocumentationCard,
  triggerPallasAlgoCdc,
  fetchCodeAssistCancerWarnings,
  setCancerCodeWarningsList,
  getCoderSessionTimeCalculated,
  setIsSessionStarted,
} from "../pages/Coder/redux/CoderSlicer";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
} from "../pages/EpisodeList/redux/EpisodeListSlicer";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import { downloadPDF } from "./utils";
import { parse, format, isValid } from "date-fns";
import { acceptCode, calculateDrgCode } from "../CodingScreen/Service";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import CodeBookUsa from "../CodeBook/CodeBookUsa";
import CodeBookDev from "../CodeBook/CodeBookDev";
import { toast, ToastContainer } from "react-toastify";
import { fetchCodersData } from "../Codeworkflow/CoderView/redux/CoderScreenSlice";
import { getAuditorViewData } from "../Codeworkflow/AuditorView/redux/AuditorViewSlicer";
import axiosInstance from "../../axiosinterceptor";
import { clearCodePathHistory } from "./CodeSearch/redux/codeSearchSlice";
import {
  handleResetSearch,
  setActiveTab,
  setActiveIcon,
} from "../CodeBook/redux/CodeBookSlicer";
import WarningPanel from "./CodeSearch/WarningPanel";
import CodeSearchUSA from "./CodeSearch/CodeSearchUSA";
import DocumentViewer from "../DocumentViewer/DocumentViewer";
import CancerWarningPanel from "./CodeSearch/CancerWarningPanel";
import achiCodesData from "../CodingScreen/achi_codes.json";
import { getHistoricalPatientInfo, resetHistoricalPatientInfo } from "../EpisodeStatus/Redux/EpisodeStatusSlice";
import GenerateCDQ from "../EpisodeStatus/generateCdq/GenerateCDQ";
import NudgingCard from "../Nudging/Nudging";
import { nudgingEvaluationAPI, nudgingSessionAPI, resetNudgingEvaluationResponse } from "../Nudging/NudgingSlicer";


const CodeAssistWrapper = (onFinalizeCode) => {
  const location = useLocation();
  const [drgData, setDrgData] = useState({});
  const { activeTab, activeIcon } = useSelector((state) => state.codeBook);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;
  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;
  const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const codebooksanhcEnv = process.env.REACT_APP_FLAG_SAN_HC;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebookhealthecareEnv = process.env.REACT_APP_FLAG_HEALTHECARE
  const { selectedQueueworkSpace } = useSelector((state) => state.episodeList);
  const [batchInsertCompleted, setBatchInsertCompleted] = useState(false);
  const isFromAccelerate =
    location.state?.fromAccelerate ||
    sessionStorage.getItem("isFromAccelerate") === "true";
  const [isDrgConfirmedSession, setIsDrgConfirmedSession] = useState(false);
  // console.log(selectedQueueworkSpace,"selectedQueueworkSpace")
  const navigate = useNavigate();
  //  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL
  // const [activeIcon, setActiveIcon] = useState();
  // const [activeTab, setActiveTab] = useState(
  //   codebookdevEnv ? "ICD 10 AM Index" : "ICD 10 CM Index"
  // );
  const codebooknmhsEnv = process.env.REACT_APP_FLAG_NMHS;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const pallasaiTestCodebookEnv = process.env.REACT_APP_FLAG_PALLASAI_TEST;
  const codebookfigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const theme = useTheme();
  const isBatchInsertingRef = useRef(false);
  const trackingIntervalRef = useRef(null);
  const waitForUserActionRef = useRef(false);
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openStatusUpdatedModal, setOpenStatusUpdatedModal] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(
    codebookusaEnv ? "42.1" : null,
  );
  const [auditedStatus, setAuditedStatus] = useState(false);
  const [selectedCodeBookCode, setSelectedCodeBookCode] = useState(null);
  const [selectedTabKeyCoding, setSelectedTabKeyCoding] = useState(null);
  const [enableFinalize, setEnableFinalize] = useState(false);
    const [openGenerateCDQ, setOpenGenerateCDQ] = useState(false);
    const [sendCDQ, setSendCDQ] = useState(false);
  const [skipAcceptApi, setSkipAcceptApi] = useState(false);
  const [drgloading, setDrgLoading] = useState(false);
  const [currentEpisode, setCurrentEpisode] = useState();
  const [currentStatus, setCurrentStatus] = useState("");
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const [iconDisplay, setIconDispaly] = useState(true);
  const [isSendingCDQ, setIsSendingCDQ] = useState(false);
  const {
      loading: nudgingSessionResponseLoading,
      data: nudgingSessionResponseData,
      error: nudgingSessionResponseError,
  } = useSelector((state) => state.nudging.nudgingSessionResponse);
  const [deletedCodes, setDeletedCodes] = useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("deletedCodes");
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  });
  const nudgeSessionExists=sessionStorage.getItem("nudging_session_token") 
  // hasCofOrClusterChanged - initialize from session when isFromAccelerate is true
  const [hasCofOrClusterChanged, setHasCofOrClusterChanged] = useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("hasCofOrClusterChanged");
      return stored ? JSON.parse(stored) : false;
    }
    return false;
  });
  const [newlyInsertedCodes, setNewlyInsertedCodes] = useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("newlyInsertedCodes");
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  });
  const [actionPerformed, setActionPerformed] = useState(false);
  // Custom hook to show popup when user navigates way with unsaved changes
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    // Don't block when navigating between modules
    if (currentLocation.pathname === nextLocation.pathname) return false;

    // Don't block if navigating between Accelerate ↔ Assist
    const isAccelerateToAssist =
      (currentLocation.pathname === "/coder" ||
        currentLocation.pathname === "/Auditor-Coding-Screen") &&
      (nextLocation.pathname === "/Code-Assist" ||
        nextLocation.pathname === "/Auditor-CodeAssist-Screen");

    const isAssistToAccelerate =
      (currentLocation.pathname === "/Code-Assist" ||
        currentLocation.pathname === "/Auditor-CodeAssist-Screen") &&
      (nextLocation.pathname === "/coder" ||
        nextLocation.pathname === "/Auditor-Coding-Screen");

    if (isAccelerateToAssist || isAssistToAccelerate) return false;

    // Block if there are unsaved changes

    return hasUnsavedChanges && !isDrgConfirmedSession;
  });
  const [isStatusUpdated, setIsStatusUpdated] = useState(false);
  const [pendingCode, setPendingCode] = useState(null);
  const [pendingType, setPendingType] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState();
  const [cancerWarningModal, setCancerWarningModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [hasDenyConfirmation, setHasDenyConfirmation] = useState(false);
  const warningRequestIdRef = useRef(0);
  const [isCheckingWarnings, setIsCheckingWarnings] = useState(false);
  const [selectedActionType, setSelectedActionType] = useState(null);
  const checkModalStatus = JSON.parse(
    sessionStorage.getItem("episode-status-modal"),
  );
  const [currentEpisodeNumber, setCurrentEpisodeNumber] =
    useState(checkModalStatus);
  const [showCodeSearch, setShowCodeSearch] = useState(() => {
    const storedShowCodeSearch = sessionStorage.getItem("showCodeSearch");
    return storedShowCodeSearch ? JSON.parse(storedShowCodeSearch) : false;
  });
  const { line_assignment_id } = location.state || "";
  const lineAssignmentId = sessionStorage.getItem("lineAssignmentId");
  const codeHistoryRef = useRef(null);
  useEffect(() => {
    sessionStorage.setItem("showCodeSearch", JSON.stringify(showCodeSearch));
  }, [showCodeSearch]);
  useEffect(() => {
    dispatch(getAuditorNamesAndQueues());
    dispatch(getCoderNamesInActions());
    sessionStorage.setItem("lineAssignmentId",line_assignment_id)
    if (lineAssignmentId) {
      sessionStorage.setItem("lineAssignmentId", line_assignment_id);
    }
  }, []);
  const [hasCodesSequenced, setHasCodesSequenced] = useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("hasCodesSequenced");
      return stored ? JSON.parse(stored) : false;
    }
    return false;
  });
  useEffect(() => {
    return async() => {
      sessionStorage.removeItem("lineAssignmentId");
    };
  }, []);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const [headerText, setHeaderText] = useState("Code Assist");
  const [buttonText, setButtonText] = useState("CodeAssist");
  const { episodeList } = useSelector((state) => state);
  const [weightValue, setweightValue] = useState("");
  const [fetchData1, { data: data1, isLoading: isLoading1, error: error1 }] =
    useLazyGetData2Query();
  const [isFetchingData1, setIsFetchingData1] = useState(false);
  const [drgValue, setDrgValue] = useState(data1?.data?.meta?.drg_code);
    const [mvHours, setMvHours] =useState(() => {
      if (isFromAccelerate) {
        const stored = sessionStorage.getItem("mvHoursState");
        return stored ? JSON.parse(stored) : null;
      }
      return null;
    })
   const [nivHours, setNivHours] =useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("nivHoursState");
      return stored ? JSON.parse(stored) : null;
    }
    return null;
  })

  const [reimbursementValue, setReimbursementValue] = useState("");
  const [drgModalVisible, setDrgModalVisible] = useState(false);
  const [actionsBtnDisable, setActionsBtnDisable] = useState(false);
  const dispatch = useDispatch();
  const [accepted, setAccepted] = useState({});
  const [acceptedCodes, setAcceptedCodes] = useState(() => {
    if (isFromAccelerate) {
      const stored = sessionStorage.getItem("acceptedCodes");
      return stored ? JSON.parse(stored) : {};
    }
    return {};
  });
   const hasUnsavedChanges =
      newlyInsertedCodes.length > 0 ||
      deletedCodes.length > 0 ||
      hasCofOrClusterChanged ||
      hasCodesSequenced ||
      Object.keys(acceptedCodes).length > 0;
  const drgOptionsLoading = useSelector(
    (state) => state?.coder?.loadingDrgOptionsData,
  );
  const typeOfPatient = lastCodedEpisode?.selectedEpisode?.type_patient;

  const insertingCodes = new Set();
  const [isLoadingCodingScreen, setIsLoadingCodingScreen] = useState(false);
  const [copiedCodes, setCopiedCodes] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const last_hcp_line_id = sessionStorage.getItem("last_hcp_line_id");
  const lastHcpLineId = sessionStorage.getItem("last_hcp_line_id");
  const [isDrgConfirmed, setIsDrgConfirmed] = useState(false);
  const [drgConfirmedStatusUpdate, setdrgConfirmedStatusUpdate] =
    useState(false);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [selectedAuditorId, setSelectedAuditorId] = useState(null);
  const [selectedAuditorQueueIds, setSelectedAuditorQueueIds] = useState([]);
  const [selectedCoderInActionId, setSelectedCoderInActionId] = useState(null);
  const [reviewReason, setReviewReason] = useState("");
  const [coderForReviewId, setCoderForReviewId] = useState(null);
  const [auditorForReviewId, setAuditorForReviewId] = useState(null);
  const currentPage = sessionStorage.getItem("currentPage");
  const [showMyActionsDropdown, setShowMyActionsDropdown] = useState(false);
  const isLockedCoder = data1?.data?.meta?.is_locked;
  const { drgSelectedVersion, selectedDrgData,cdqRequest } = useSelector(
    (state) => state.episodeStatus,
  );
  const isDCID = data1?.data?.meta?.is_DCID === true;
  let isActionPerformed = false;
  const skipNextAutoDrgCalc = useRef(false);
  const isPallasAlgoApplied = useSelector(
    (state) => state.coder.isPallasAlgoApplied,
  );

  const {
    episodesData,
    isEpisodesLoading,
    currentClusterID,
    clusterIDs,
    selectedMissingNotesOptions,
    isSessionStarted,
  } = useSelector((state) => state.coder);
  const {
    injuryWithActivity,
    externalCauseCodes,
    placeOfOccurrence,
    activityCodes,
    injuryWithoutActivity,
    chronicCodes,
  } = useSelector((state) => state.codeSearch);
  const {
    clusterCodeWarningsIsLoading,
    clusterCodeWarningsList,
    clusterCodeWarningsError,
  } = useSelector((state) => state.coder.clusterCodeWarnings);

  const {
    cancerCodeWarningsIsLoading,
    cancerCodeWarningsList,
    cancerCodeWarningsError,
  } = useSelector((state) => state.coder.cancerCodeWarnings);

  const [codePathHistory, setCodePathHistory] = useState([]);
  const codePathHistory1 = useSelector(
    (state) => state.codeSearch.codePathHistory,
  );

  const allDRGCodesTableData = useSelector(
    (state) => state?.coder?.drgOptionsData,
  );
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissionList = Object.keys(permissions);
  const { codeHistoryCard, codeAssistWindowCard, codeBookCard } = useSelector(
    (state) => state.codeAssist.coderCard,
  );
  const { documentationCard, codingScreenCard } = useSelector(
    (state) => state.coder.coderCard,
  );
const nudgingCard = useSelector((state) => state.codeAssist.nudgingCard); 

    const {
      loading: coderSessionStartLoading,
      data: coderSessionStartData,
      error: coderSessionStartError,
    } = useSelector((state) => state.coder.coderSessionStart);

  const [diagnosisStates, setDiagnosisStates] = useState(() => {
    const getItem = (key, fallback) => {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    };

    if (isFromAccelerate) {
      return getItem("diagnosisStates", {
        principal: data1?.data?.principal_diagnosis ?? [],
        additional: data1?.data?.additional_diagnoses ?? [],
        procedure: data1?.data?.procedure_codes ?? [],
      });
    }

    return {
      principal: getItem(
        "principalDiagnosisState",
        data1?.data?.principal_diagnosis ?? [],
      ),
      additional: getItem(
        "additionalDiagnosisState",
        data1?.data?.additional_diagnoses ?? [],
      ),
      procedure: getItem(
        "procedureCodesState",
        data1?.data?.procedure_codes ?? [],
      ),
    };
  });
  const [trackHistory, setTrackHistory] = useState(() => {
    const storedTrackHistory = sessionStorage.getItem("trackHistory");
    return storedTrackHistory ? JSON.parse(storedTrackHistory) : [];
  });

  const [redoStack, setRedoStack] = useState(() => {
    const storedRedoStack = sessionStorage.getItem("redoStack");
    return storedRedoStack ? JSON.parse(storedRedoStack) : [];
  });
  const currentClusterIndex = clusterIDs?.indexOf(currentClusterID);
  const nextClusterCurrentIndex = clusterIDs[currentClusterIndex + 1];
  // const queueType = location.state?.queue_type;
  // const queueID = location.state?.queue_id;
  const [isCalculatingDrg, setIsCalculatingDrg] = useState(false);

  const [navQueue, setNavQueue] = useState({
    queueType: location.state?.queue_type ?? null,
    queueID: location.state?.queue_id ?? null,
  });


   const stopcoderSessionTimeCalculated = async () => {
    if (trackingIntervalRef.current) {
      clearInterval(trackingIntervalRef.current);
      trackingIntervalRef.current = null;
    }
    try {
      const payload = {
        hcp_line_id: last_hcp_line_id || "",
        request_from:
          currentPage === "coderview" || currentPage === "episodeList"
            ? "U"
            : currentPage === "auditorPage"
            ? "AU"
            : "",
        session_token: sessionStorage.getItem("coder_tracking_token"),
      };
  
      const result = await dispatch(
        getCoderSessionTimeCalculated(payload)
      ).unwrap();
  
      if (result?.statusCode === 200) {
        dispatch(setIsSessionStarted(false));
        sessionStorage.removeItem("coder_tracking_token")
      }
    } catch (error) {
      console.error("Session calculation failed:", error);
    }
  };
  const queueType = navQueue.queueType;
  const queueID = navQueue.queueID;
  const toggleCollapse = (collapseNumber) => {
    if (showCodeSearch) {
      if (collapseNumber === 1) {
        dispatch(setCodeHistoryCard(!codeHistoryCard));
        dispatch(setCodeAssistWindowCard(true));
      } else if (collapseNumber === 2) {
        dispatch(setCodeAssistWindowCard(!codeAssistWindowCard));
        dispatch(setCodeBookCard(true));
      } else if (collapseNumber === 3) {
        dispatch(setCodeBookCard(!codeBookCard));
        dispatch(setCodeAssistWindowCard(true));
      }
    } else {
      if (collapseNumber === 2) {
        dispatch(setCodeAssistWindowCard(!codeAssistWindowCard));
        dispatch(setCodeBookCard(true));
      } else if (collapseNumber === 3) {
        dispatch(setCodeBookCard(!codeBookCard));
        dispatch(setCodeAssistWindowCard(true));
      }
      else if (collapseNumber === 4) {
      dispatch(setNudgingCard(!nudgingCard));
      dispatch(setCodeAssistWindowCard(true));
      dispatch(setCodeBookCard(true));
    }
    }
  };
  const new_hcp_line_id = sessionStorage.getItem("last_hcp_line_id");
  const diagnosisStatesRef = useRef(diagnosisStates);
  const drgRequestIdRef = useRef(0);
  const rulesEngineRequestIdRef = useRef(0);
  useEffect(() => {
    diagnosisStatesRef.current = diagnosisStates;
  }, [diagnosisStates]);
  useEffect(() => {
    sessionStorage.setItem(
      "hasCofOrClusterChanged",
      JSON.stringify(hasCofOrClusterChanged),
    );
  }, [hasCofOrClusterChanged]);
  useEffect(() => {
    sessionStorage.setItem(
      "hasCodesSequenced",
      JSON.stringify(hasCodesSequenced),
    );
  }, [hasCodesSequenced]);
    useEffect(() => {
    sessionStorage.setItem("mvHoursState", JSON.stringify(mvHours));
  }, [mvHours]);
      useEffect(() => {
    sessionStorage.setItem("nivHoursState", JSON.stringify(nivHours));
  }, [nivHours]);
  // Persist newlyinsertedcodeswhen fromAccelerate is true
  useEffect(() => {
    sessionStorage.setItem(
      "newlyInsertedCodes",
      JSON.stringify(newlyInsertedCodes),
    );
  }, [newlyInsertedCodes]);
  useEffect(() => {
    sessionStorage.setItem("deletedCodes", JSON.stringify(deletedCodes));
  }, [deletedCodes]);
  useEffect(() => {
    sessionStorage.setItem("acceptedCodes", JSON.stringify(acceptedCodes));
  }, [acceptedCodes]);
  const resetQueueFromNavigation = () => {
    setNavQueue({
      queueType: null,
      queueID: null,
    });
  };

  useEffect(() => {
    if (!location.state?.queue_type && !location.state?.queue_id) {
      // New navigation WITHOUT queue info → reset
      setNavQueue({
        queueType: null,
        queueID: null,
      });
    } else {
      // Navigation WITH queue info → set new values
      setNavQueue({
        queueType: location.state.queue_type,
        queueID: location.state.queue_id,
      });
    }
  }, [location.key]);

  // useEffect(() => {
  //     const fetchAll = async () => {
  //       try {
  //         setIsLoadingCodingScreen(true);
  //         setDrgLoading(true);

  //         const results = await Promise.all([fetchData1()]);
  //         // console.log("All API responses:", results);
  //         // Step 1: Trigger the Step Function
  //         const res = await dispatch(fetchAllCodesbyStepFunction());
  //         const executionArn = res?.payload?.executionArn;

  //         if (executionArn) {
  //           let status;

  //           // Step 2: Poll until status is SUCCEEDED
  //           while (true) {
  //             const progressRes = await dispatch(
  //               fetchAllCodesProgress(executionArn)
  //             );
  //             status = progressRes?.payload?.status;

  //             if (status === "SUCCEEDED") {
  //               break; // exit loop
  //             }

  //             if (status === "FAILED") {
  //               console.warn("Step function execution failed.");
  //               break; // exit loop even on failure
  //             }

  //             // Optional: log intermediate status
  //             console.log("Current status:", status);

  //             // Delay before next poll
  //             await new Promise((resolve) => setTimeout(resolve, 3000));
  //           }
  //         } else {
  //           console.warn("executionArn not found. Skipping polling.");
  //         }
  //       } catch (error) {
  //         console.error("Error during step function or polling:", error);
  //       } finally {
  //         // Step 3: Always fetch additional data
  //         try {
  //           await fetchData1();
  //         } catch (dataError) {
  //           console.error("Error in fetchData1:", dataError);
  //         }

  //         setIsLoadingCodingScreen(false);
  //         setDrgLoading(false);
  //       }
  //     };

  //     fetchAll();
  //   }, [new_hcp_line_id]);
  useEffect(() => {
    return () => {
      // THIS RUNS WHEN COMPONENT UNMOUNTS (route change, tab switch, etc.)
      if (new_hcp_line_id) {
        // console.log("Component unmounted → unlocking episode");

        dispatch(
          getunlockEpisode({ hcp_line_id: String(new_hcp_line_id) }), // send as string
        )
          .unwrap()
          .then((res) => {
            console.log(res?.message);
          })
          .catch((err) => {
            console.log(err?.message);
          });
      }
    };
  }, [dispatch, new_hcp_line_id]);
  useEffect(() => {
  if (sendCDQ && cdqRequest) {
    handleSendToAudit("awaitingCDQ");
    setSendCDQ(false);
  }
}, [sendCDQ, cdqRequest]);
  useEffect(() => {
    if (isFromAccelerate) return;
    if (data1?.data?.meta?.hours_of_mechanical_ventilation !== undefined) {
      setMvHours(data1.data.meta.hours_of_mechanical_ventilation);
    }
  }, [data1]);
   useEffect(() => {
      if (isFromAccelerate) return;
      if (data1?.data?.meta?.hours_of_non_invasive_ventilation !== undefined) {
        setNivHours(data1.data.meta.hours_of_non_invasive_ventilation);
      }
    }, [data1]);
  useEffect(() => {
    if (isFromAccelerate) return;
    if (newlyInsertedCodes.length > 0 || deletedCodes.length > 0) {
      setIsDrgConfirmedSession(false);
    }
  }, [newlyInsertedCodes, deletedCodes]);
  useEffect(() => {
    if (isFromAccelerate) return;
    const handleBeforeUnload = (e) => {
      const hasUnsavedChanges =
        newlyInsertedCodes.length > 0 ||
        deletedCodes.length > 0 ||
        hasCofOrClusterChanged ||
        hasCodesSequenced ||
        Object.keys(acceptedCodes).length > 0;

      if (hasUnsavedChanges && !isDrgConfirmedSession) {
        e.preventDefault();
        e.returnValue = "";
        sessionStorage.removeItem("coder_tracking_token");
        if (isSessionStarted) {
          stopcoderSessionTimeCalculated();
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [
    newlyInsertedCodes,
    deletedCodes,
    isSessionStarted,
    isDrgConfirmedSession,
    hasCofOrClusterChanged,
    hasCodesSequenced,
    acceptedCodes,
  ]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        dispatch(resetNudgingEvaluationResponse());
        setIsLoadingCodingScreen(true);
        setDrgLoading(true);
        // setWaitTillLoad(true);

      const response = await fetchData1(); 
      const mrn = response?.data?.data?.meta?.medical_record_number;
      const episodeIdentifier = response?.data?.data?.meta?.episode_identifier;

      if (mrn && episodeIdentifier) {
        dispatch(
          getHistoricalPatientInfo({
            mrn,
            episode_identifier: episodeIdentifier,
          })
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadingCodingScreen(false);
      setDrgLoading(false);
      // setWaitTillLoad(false);
    }
  };

  fetchAll();

  return () => {
    dispatch(resetHistoricalPatientInfo());
  };
}, [new_hcp_line_id]);

  // useEffect(() => {
  //   const storedFilters = sessionStorage.getItem("filters");
  //   const newEpisodeListFilterObj = storedFilters
  //     ? JSON.parse(storedFilters)
  //     : null;

  //   const payload = newEpisodeListFilterObj || episodeListFilterObj || [];

  //   dispatch(getFilterEpisodeLists(payload));
  // }, [dispatch, episodeListFilterObj]);

  const newEpisodeRecord = episodesFilterList?.episode?.find(
    (episode) => episode?.hcp_line_id === Number(last_hcp_line_id),
  );
  const episodeSelected =
    episodeList?.selectedEpisode &&
    Object.keys(episodeList.selectedEpisode).length !== 0
      ? episodeList.selectedEpisode
      : newEpisodeRecord;

  useEffect(() => {
    dispatch(selectedEpisodeList(episodeSelected));
  }, [episodeSelected]);
  useEffect(() => {
    sessionStorage.setItem("trackHistory", JSON.stringify(trackHistory));
  }, [trackHistory]);

  useEffect(() => {
    sessionStorage.setItem("redoStack", JSON.stringify(redoStack));
  }, [redoStack]);

const handleUndo = () => {
  if (trackHistory.length === 0) return;

  setRedoStack((prev) => {
    const newRedoStack = [
      {
        diagnosisStates,
        acceptedCodes,
        newlyInsertedCodes,
        deletedCodes,
        hasCofOrClusterChanged,
        hasCodesSequenced,
      },
      ...prev,
    ];
    sessionStorage.setItem("redoStack", JSON.stringify(newRedoStack));
    return newRedoStack;
  });

  const lastState = trackHistory[trackHistory.length - 1];
  setDiagnosisStates(lastState.diagnosisStates);
  setAcceptedCodes(lastState.acceptedCodes);
  setNewlyInsertedCodes(lastState.newlyInsertedCodes ?? []);
  setDeletedCodes(lastState.deletedCodes ?? []);
  setHasCofOrClusterChanged(lastState.hasCofOrClusterChanged ?? false);
  setHasCodesSequenced(lastState.hasCodesSequenced ?? false);

  if (codebookusaEnv) {
    syncCofWarning(lastState.diagnosisStates);
  }
  setTrackHistory((prev) => {
    const newTrackHistory = prev.slice(0, -1);
    sessionStorage.setItem("trackHistory", JSON.stringify(newTrackHistory));
    return newTrackHistory;
  });

  setHasCofOrClusterChanged(true);
};

const handleRedo = () => {
  if (redoStack.length === 0) return;

  setTrackHistory((prev) => [
    ...prev,
    {
      diagnosisStates,
      acceptedCodes,
      newlyInsertedCodes,
      deletedCodes,
      hasCofOrClusterChanged,
      hasCodesSequenced,
    },
  ]);

  const nextState = redoStack[0];
  setDiagnosisStates(nextState.diagnosisStates);
  setAcceptedCodes(nextState.acceptedCodes);
  setNewlyInsertedCodes(nextState.newlyInsertedCodes ?? []);
  setDeletedCodes(nextState.deletedCodes ?? []);
  setHasCofOrClusterChanged(nextState.hasCofOrClusterChanged ?? false);
  setHasCodesSequenced(nextState.hasCodesSequenced ?? false);

  if (codebookusaEnv) {
    syncCofWarning(nextState.diagnosisStates);
  }
  setRedoStack((prev) => {
    const newRedoStack = prev.slice(1);
    sessionStorage.setItem("redoStack", JSON.stringify(newRedoStack));
    return newRedoStack;
  });

  setHasCofOrClusterChanged(true);
};
  const isDiagnosisEmpty = useMemo(() => {
    // console.log("data1:", data1);

    const isPrincipalEmpty = !data1?.data?.principal_diagnosis?.some(
      (item) =>
        (item?.code && item.code.trim()) ||
        (item?.description && item.description.trim()),
    );
    const isAdditionalEmpty = !data1?.data?.additional_diagnoses?.some(
      (item) =>
        (item?.code && item.code.trim()) ||
        (item?.description && item.description.trim()),
    );
    const isProcedureEmpty = !data1?.data?.procedure_codes?.some(
      (item) =>
        (item?.code && item.code.trim()) ||
        (item?.description && item.description.trim()),
    );

    const result = isPrincipalEmpty && isAdditionalEmpty && isProcedureEmpty;
    // console.log("isDiagnosisEmpty:", result);
    return result;
  }, [data1]);

  useEffect(() => {
    if (!isFromAccelerate && isDiagnosisEmpty) {
      setShowCodeSearch(true);
    } else {
      setShowCodeSearch(false);
    }
  }, [isDiagnosisEmpty]);

  // useEffect(() => {
  //   if (showCodeSearch === false) {
  //     dispatch(handleResetSearch());
  //     dispatch(setActiveTab(codebookusaEnv ? "ICD 10 CM Index":"ICD 10 AM Index"));
  //     dispatch(setActiveIcon("ICD"));
  //     dispatch(clearCodePathHistory());
  //   }
  // }, [showCodeSearch]);
  useEffect(() => {
    if (showCodeSearch === false) {
      dispatch(handleResetSearch());

      // Set active tab based on environment and patient type
      if (codebookusaEnv && typeOfPatient !== "outPatient") {
        dispatch(setActiveTab("ICD 10 CM Index"));
      } else if (codebookusaEnv && typeOfPatient === "outPatient") {
        dispatch(setActiveTab("PCS Index"));
      } else {
        dispatch(setActiveTab("ICD 10 AM Index"));
      }

      dispatch(setActiveIcon("ICD"));
      dispatch(clearCodePathHistory());
    }
  }, [showCodeSearch]);
  const printRef = useRef();
  const hasPrintableData =
    Array.isArray(codePathHistory1) && codePathHistory1.length > 0;

  const handleDownloadPdf = () => {
    if (!hasPrintableData) {
      // console.warn("⚠️ No data to print. Skipping PDF generation.");
      return; // don’t call downloadPDF if no data
    }
    downloadPDF(printRef); // Call the named export function
  };
  const cleanCodes = (codes) =>
    codes?.map((code) =>
      code?.replace(/[.\-']/g, "").replace(/\s*\[.*?\]\s*/g, ""),
    );

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const parsedDate = parse(dateString, "dd-MM-yyyy", new Date());
    return isValid(parsedDate) ? parsedDate : null;
  };
  const meta = data1?.data?.meta || {};
  const separationDate = parseDate(meta?.separation_date);
  const isCodingDataEmpty = (codingData) => {
    const { principal, additional, procedure } = codingData || {};

    const isPrincipalEmpty =
      !Array.isArray(principal) ||
      principal.length === 0 ||
      principal.every((item) => !item?.code);

    const isAdditionalEmpty =
      !Array.isArray(additional) ||
      additional.length === 0 ||
      additional.every((item) => !item?.code);

    const isProcedureEmpty =
      !Array.isArray(procedure) ||
      procedure.length === 0 ||
      procedure.every((item) => !item?.code);

    return isPrincipalEmpty && isAdditionalEmpty && isProcedureEmpty;
  };

  const isEmpty = isCodingDataEmpty(diagnosisStates);

  const calculate_drg = async (isActionPerformed = false) => {
    const hcp_line_id = sessionStorage.getItem("last_hcp_line_id");
    const module_name =
      location.pathname === "/Code-Assist" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "Code Assist"
        : "Code Accelerate";
    if (!data1?.data) return;
    const meta = data1.data.meta || {};

    const requestId = ++drgRequestIdRef.current;

    //  Read latest state once via ref, use everywhere
    const { principal, additional, procedure } = diagnosisStatesRef.current;

    const procedures = cleanCodes(procedure.map((item) => item?.code));
    const additionalDiagnoses = cleanCodes(
      (additional ?? [])
        .filter((item) => typeof item?.code === "string")
        .map((codeItem) => {
          const code = codeItem.code;
          return ["1", "2"].includes(code[1]) ? code.slice(2) : code.slice(1);
        }),
    );

    const principalDiagnosis =
      principal.length > 0
        ? cleanCodes([
            ["1", "2"].includes(principal[0]?.code?.[1])
              ? principal[0]?.code?.slice(2)
              : principal[0]?.code?.slice(1),
          ])[0]
        : "";

    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate,
    );
       const sdf =
  admissionDate.getTime() === separationDate.getTime() ? 1 : 0;
    const payload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: mvHours || 0,
      niv: nivHours || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: meta.los,
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });

    const newPayload = {
      hcp_line_id: hcp_line_id,
      module_name: module_name,
      is_confirmed:actionPerformed || isActionPerformed,
      drg_payload: { ...payload },
    };

    //  Read latest state once via ref, use everywhere
    const allPrincipalCodes = principal.map((item) => item?.code);
    const allAdditionalCodes = additional.map((item) => item?.code);
    const allProcedureCodes = procedure.map((item) => item?.code);

    try {
      setDrgLoading(true);
      const response = await calculateDrgCode(newPayload);

      if (requestId !== drgRequestIdRef.current) {
        // console.log("Stale DRG response discarded");
        return;
      }

      const version = codebookusaEnv ? "42.1" : "11";
      const versionObj = response.data?.drgs?.find((item) => item[version]);
      const selectedDrgVersion = versionObj?.[version];

      setDrgData(response.data);

      const displayVersion = response.data?.display_version;
      const displayVersionObj = response.data?.drgs?.find(
        (item) => item[displayVersion],
      );
      const selectedDisplayDrg = displayVersionObj?.[displayVersion];

      const pallasPriority =
        selectedDisplayDrg?.additional_information?.pallas_priority;
      const sessionToken = sessionStorage.getItem("pallas_session_token");
      const isRecentlyConfirmed = sessionStorage.getItem("confirmedRecently");
      const isRecentlyConfirmedStatus = isRecentlyConfirmed === "true";

      let finalPriority = null;
      if (pallasPriority === null && !isEmpty && !isRecentlyConfirmedStatus) {
        finalPriority = "OPTIMISED_REQUEST";
      } else if (
        pallasPriority?.toLowerCase() === "high" &&
        !isRecentlyConfirmedStatus
      ) {
        finalPriority = "HIGH";
      } else if (
        pallasPriority?.toLowerCase() === "ultra high" &&
        !isRecentlyConfirmedStatus
      ) {
        finalPriority = "ULTRA_HIGH";
      } else {
        finalPriority = "FINAL_REQUEST";
      }

      const cdcpayload = {
        hcp_line_id: lastHcpLineId,
        drg_code: selectedDisplayDrg.drg,
        drg_version: displayVersion,
        is_confirmed: isRecentlyConfirmedStatus ? true : false,
        principal_diagnosis_code: allPrincipalCodes.join(","),
        additional_diagnoses_code: allAdditionalCodes,
        procedure_codes: allProcedureCodes,
        weight:
          selectedDisplayDrg.weight === "can't determine"
            ? null
            : selectedDisplayDrg.weight,
        pallas_priority: finalPriority,
        session_token: sessionToken,
      };

      if (isPallasAlgoApplied) {
        dispatch(triggerPallasAlgoCdc(cdcpayload));
      }
      if (selectedDisplayDrg?.drg && 
    selectedDisplayDrg?.weight !== undefined && 
    selectedDisplayDrg?.weight !== null) {
  
  fetchNudgingData(
    diagnosisStatesRef.current,
    selectedDisplayDrg.drg,
    selectedDisplayDrg.weight, // This can be 0 or "can't determine"
    drgSelectedVersion || response.data?.grouper_versions?.[0]
  );
}

      const drgValue = selectedDrgVersion?.drg ?? "N/A";
      const weightValue = selectedDrgVersion?.weight ?? "N/A";
      const reimbursementValue = selectedDrgVersion?.reimbursement ?? "N/A";

      setDrgValue(drgValue);
      setweightValue(weightValue);
      setReimbursementValue(reimbursementValue);
    } catch (error) {
      if (requestId !== drgRequestIdRef.current) return;
      // console.error("Error submitting diagnosis:", error);
    } finally {
      if (requestId === drgRequestIdRef.current) {
        setDrgLoading(false);
        sessionStorage.setItem("confirmedRecently", false);
      }
    }
  };
  const handleDrgInformation = () => {
    if (!data1?.data) return;
    const meta = data1.data.meta || {};
    const { principal, additional, procedure } = diagnosisStates;
    const procedures = cleanCodes(procedure.map((item) => item?.code));
    const additionalDiagnoses = cleanCodes(
      additional.map((item) => item?.code?.slice(1)),
    );
    const principalDiagnosis =
      principal.length > 0 ? cleanCodes([principal[0]?.code?.slice(1)])[0] : "";
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate,
    );
       const sdf =
  admissionDate.getTime() === separationDate.getTime() ? 1 : 0;
    const payload = replaceEmptyWithNull({
      hcp_line_id: lastHcpLineId,
      drg: drgValue,
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: mvHours || 0,
      niv: nivHours || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: meta.los,
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });
    // dispatch(fetchDrgInformation(payload));
  };
  const getCOFValue = (code) => {
    if (!code) return null;
    return code.charAt(0); // Y / 1 / 2
  };

  const handleDRGOptions = () => {
    if (!data1?.data) return;
    const meta = data1.data.meta || {};

    const { principal, additional, procedure } = diagnosisStates;
    const procedures = procedure.map((item) => item?.code);
    const additionalDiagnoses = cleanCodes(
      additional.map((item) => item?.code?.slice(1)),
    );
    const principalDiagnosis =
      principal.length > 0 ? cleanCodes([principal[0]?.code?.slice(1)])[0] : "";
    const diagnosisCodes = [
      ...diagnosisStates.principal,
      ...diagnosisStates.additional,
    ].map((item) => ({
      code: item.code,
      Description: item.description,
    }));
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate,
    );
       const sdf =
  admissionDate.getTime() === separationDate.getTime() ? 1 : 0;
    const payload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: mvHours || 0,
      niv: nivHours || 0,
      procedure_codes: procedures || [],
      diagnosis_code: diagnosisCodes || [],
      los: meta.los,
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });

    dispatch(fetchDrgOptions(payload));
    setDrgModalVisible(true);
  };
  const updateDiagnosisStateFromSelectedCode = (
    diagnosisState,
    selectedCode,
  ) => {
    const principalCode = selectedCode.principal_diagnosis;
    const additionalCodes = selectedCode.additional_diagnoses || [];
    const procedureCodes = Array.isArray(selectedCode.procedure_codes_main)
      ? selectedCode.procedure_codes_main
      : [selectedCode.procedure_codes_main];

    const allDiagnosisItems = [
      ...(diagnosisState.principal || []),
      ...(diagnosisState.additional || []),
    ];

    const getDiagnosisEntry = (code) => {
      const cleaned = code;
      return allDiagnosisItems.find((item) => item.code === cleaned);
    };

    const newPrincipal = principalCode
      ? [getDiagnosisEntry(principalCode)].filter(Boolean)
      : [];

    const newAdditional = additionalCodes
      .map((code) => getDiagnosisEntry(code))
      .filter(Boolean)
      .filter((entry) => !newPrincipal.some((p) => p.code === entry.code));

    const getProcedureEntry = (code) => {
      const cleaned = code;
      return (diagnosisState.procedure || []).find((p) => p.code === cleaned);
    };

    const newProcedures = procedureCodes.map(getProcedureEntry).filter(Boolean);

    return {
      principal: newPrincipal,
      additional: newAdditional,
      procedure: newProcedures,
    };
  };
  const handleOkClick = () => {
    setSkipAcceptApi(false);
    const lastHcpLineId = sessionStorage.getItem("last_hcp_line_id");
    const drgKey =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "audit_drg_code"
        : "drg_code";
    if (selectedRowIndex === null) {
      alert("Please select a row");
      return;
    }

    const selectedDRG = allDRGCodesTableData[selectedRowIndex];
    // console.log("Selected DRG:", selectedDRG, diagnosisStates);
    if (!data1?.data) return;
    const meta = data1.data.meta || {};
    const { principal_diagnosis, additional_diagnoses, procedure_codes_main } =
      selectedDRG;
    const procedures = procedure_codes_main;
    const additionalDiagnoses = cleanCodes(
      additional_diagnoses.map((code) => code.slice(1)),
    );
    const principalDiagnosis = principal_diagnosis
      ? cleanCodes([principal_diagnosis.slice(1)])[0]
      : "";
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate,
    );
    const sdf =
  admissionDate.getTime() === separationDate.getTime() ? 1 : 0;
    const drgPayload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: mvHours || 0,
      niv: nivHours || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: meta.los,
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });
    // setDiagnosisStates({ principal: principalDiagnosis, additional: additionalDiagnoses, procedure: procedures});
    // console.log(diagnosisStates, "blockdiag");
    const updatedDiag = updateDiagnosisStateFromSelectedCode(
      diagnosisStates,
      selectedDRG,
    );
    const selectedPrincipal = updatedDiag.principal?.[0];
    const cof = selectedPrincipal?.code
      ? getCOFValue(selectedPrincipal.code)
      : null;

    setWarningMessage((prevWarnings = []) => {
      // remove any existing COF-related warning
      const filteredWarnings = prevWarnings.filter((w) => !w.includes("COF"));

      // if COF is NOT Y → add warning
      if (cof && cof !== "Y") {
        const cofWarning = `Code ${selectedPrincipal.code.slice(
          1,
        )} has COF ${cof}. Only COF = Y is recommended.`;

        return [cofWarning, ...filteredWarnings];
      }

      // if COF === Y → just return warnings without COF
      return filteredWarnings;
    });

    setDiagnosisStates({
      principal: updatedDiag.principal,
      additional: updatedDiag.additional,
      procedure: updatedDiag.procedure,
    });
    setDrgModalVisible(false);
  };
const saveToHistory = () => {
  setTrackHistory((prev) => [
    ...prev,
    cloneDeep({
      diagnosisStates,
      acceptedCodes,
      newlyInsertedCodes,
      deletedCodes,
      hasCofOrClusterChanged,
      hasCodesSequenced,
    }),
  ]);
  setRedoStack([]);
};
  // console.log(diagnosisStates, "alldrgassist");
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

 
  const checkCodeWarnings = async (
    newValidCodes,
    type,
    _diagnosisStates,
    triggerCode = "",
    usePassedState = false,
    isPrincipalHAC = false,
  ) => {
    const requestId = ++rulesEngineRequestIdRef.current;

    //If caller explicitly says use passed state, use it
    // Otherwise always use the ref (latest)
    const diagnosisStates = usePassedState
      ? _diagnosisStates
      : diagnosisStatesRef.current;

    // Guard if truly nothing to check, bail early
    const hasAnyCodes =
      diagnosisStates?.principal?.some((i) => i?.code) ||
      diagnosisStates?.additional?.some((i) => i?.code) ||
      diagnosisStates?.procedure?.some((i) => i?.code);

    if (!hasAnyCodes) {
      setWarningMessage([]);
      setHasDenyConfirmation(false);
      return;
    }

    // console.log("Checking warnings for codes:", newValidCodes);

    try {
      // const normalize = (code) => {
      //   if (!code) return "";
      //   return isDCID ? code.slice(2) : code.replace(/^[12]/, "").trim();
      // };

      const principalCode = diagnosisStates["principal"]?.[0]
        ? diagnosisStates["principal"][0].code
        : null;

      const additionalCodes = (diagnosisStates["additional"] || [])
        .map((item) => item?.code)
        .filter((code) => code !== principalCode);

      const uniqueAdditional = [...new Set(additionalCodes)];

      const allDiagnosisCodes = [
        ...(principalCode ? [principalCode] : []),
        ...uniqueAdditional,
      ];

      const principalDiagnosisCode = diagnosisStates["principal"]?.[0]?.code;

      const normalizedTriggerCode =
        triggerCode !== undefined
          ? triggerCode
          : newValidCodes?.[newValidCodes.length - 1]?.code ||
            diagnosisStates?.principal?.[0]?.code ||
            "";

       const warningsPayload = {
        u_agey: data1?.data?.meta?.age_y,
        u_aged: data1?.data?.meta?.age_d,
        admission_date: data1?.data?.meta?.admission_date,
        separation_date: data1?.data?.meta?.separation_date,
        total_leave_days: data1?.data?.meta?.total_leave_days,
        sex: data1?.data?.meta?.sex,
        code: normalizedTriggerCode,
        check_for: !normalizedTriggerCode
          ? ""
          : type === "procedure"
            ? "Procedure"
            : "ICD",
        additional_diagnosis_codes: uniqueAdditional,
        principal_diagnosis: principalDiagnosisCode,
        diagnosis_codes: allDiagnosisCodes,
        procedure_codes: (diagnosisStates["procedure"] || []).map(
          (item) => item?.code,
        ),
        // is_principal_hac: isPrincipalHAC,
      };

      // console.log("Warnings payload:", warningsPayload);

      try {
        setIsCheckingWarnings(true);
        const response = await axiosInstance.post(
          "/code_assist_rules_engine",
          warningsPayload,
        );
        if (requestId !== rulesEngineRequestIdRef.current) {
          console.log("Stale rules engine response discarded");
          return;
        }

        return response.data;
      } catch (error) {
        if (requestId !== rulesEngineRequestIdRef.current) return;
        throw error;
      } finally {
        if (requestId === rulesEngineRequestIdRef.current) {
          setIsCheckingWarnings(false);
        }
      }
    } catch (error) {
      console.error("Error in checkCodeWarnings:", error);
      throw error;
    }
  };

  const processWarningsResponse = (
    warningsResponse,
    newValidCodes,
    type,
    setWarningMessage,
    setPendingCode,
    setPendingType,
    setModalMessage,
    setModalVisible,
    setHasDenyConfirmation,
    options = {},
  ) => {
    const { showPopup = true, triggerCode = "" } = options;

    if (!warningsResponse?.warnings || warningsResponse.warnings.length === 0) {
      setWarningMessage([]);
      setHasDenyConfirmation(false);
      return;
    }

    // IMPORTANT: Set hasDenyConfirmation based on the response
    const hasDenyConfirm = warningsResponse.deny_confirmation === true;
    setHasDenyConfirmation(hasDenyConfirm);

    const formattedWarnings = warningsResponse.warnings.map((w) => ({
      message: w.warning_description,
      type: w.deny_confirmation === true ? "error" : "warning",
    }));

    // Replace instead of append
    setWarningMessage(formattedWarnings);

    if (showPopup) {
      const popupWarnings = warningsResponse.warnings.filter(
        (w) =>
          w.should_popup === true &&
          w.code?.replace(/[./]/g, "") === triggerCode?.replace(/[./]/g, ""),
      );

      if (popupWarnings.length > 0) {
        const allMessages = popupWarnings
          .map((w) => w.warning_description)
          .join("\n\n");

        const lastInsertedCode = newValidCodes[newValidCodes.length - 1]?.code;

        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(allMessages);
        setModalVisible(true);
      }
    }
  };
  const triggerWarnings = (
    state,
    triggerCode = "",
    isInitialLoad = false,
    isPrincipalHAC = false,
  ) => {
    const requestId = ++warningRequestIdRef.current;

    // Build separately to avoid stripping procedure codes
    const diagnosisCodes = [
      ...(state?.principal || []),
      ...(state?.additional || []),
    ]
      .filter((item) => item?.code)
      .map((item) => ({
        code: item.code.replace(/^[12]/, ""),
      }));

    const procedureCodes = (state?.procedure || [])
      .filter((item) => item?.code)
      .map((item) => ({
        code: item.code, // no stripping for procedure codes
      }));

    const allCodesForWarning = [...diagnosisCodes, ...procedureCodes];

    if (allCodesForWarning.length === 0) {
      if (requestId === warningRequestIdRef.current) {
        setWarningMessage([]);
        setHasDenyConfirmation(false);
      }
      return;
    }

    checkCodeWarnings(
      allCodesForWarning,
      "all",
      state,
      isInitialLoad ? "" : triggerCode,
      true,
      isPrincipalHAC,
    )
      .then((warningsResponse) => {
        if (requestId !== warningRequestIdRef.current) return;

        if (!warningsResponse?.warnings?.length) {
          setWarningMessage([]);
          setHasDenyConfirmation(false);
          return;
        }

        processWarningsResponse(
          warningsResponse,
          [],
          "all",
          setWarningMessage,
          setPendingCode,
          setPendingType,
          setModalMessage,
          setModalVisible,
          setHasDenyConfirmation,
          {
            showPopup: !isInitialLoad,
            triggerCode,
          },
        );
      })
      .catch((err) => {
        if (requestId !== warningRequestIdRef.current) return;
        setHasDenyConfirmation(false);
      });
  };
  const handleConfirmDrg = async () => {
    sessionStorage.setItem("confirmedRecently", true);
    setSkipAcceptApi(true);
    waitForUserActionRef.current = false;
    setNewlyInsertedCodes([]);
    setDeletedCodes([]);
    setHasCofOrClusterChanged(false);
    setHasCodesSequenced(false);
    setAcceptedCodes({});
    // console.log("entered drg",diagnosisStates?.prin[0]?.code);
    if (diagnosisStates?.principal[0]?.code === null) {
      toast.error("DRG cannot be confirmed without principal diagnosis");
      return;
    }
    setAuditedStatus(true);
    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code,
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code,
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code,
    );
  // Determine default origin based on pathname
  const isCoderPath = ["/coder", "/Code-Assist"].includes(location.pathname);
  const isAuditorPath = ["/Auditor-Coding-Screen", "/Auditor-CodeAssist-Screen"].includes(location.pathname);
  const defaultOrigin = isCoderPath ? "U" : isAuditorPath ? "AU" : "U";
  const moduleName = (location.pathname === "/coder" || location.pathname === "/Auditor-Coding-Screen") ? "Code Accelerate" : "Code Assist";
  
  // Helper function to get origin for each code
  const getOriginForCode = (item) => {
    // If the item has an origin and it's not null, use it
    if (item?.origin && item.origin !== null) {
      return item.origin;
    }
    // Otherwise use the default origin based on pathname
    return defaultOrigin;
  };
    const getDefaultDrg = (data) => {
      const version = data.display_version;
      const match = data?.drgs?.find((d) => d[version]);
      return match?.[version] ?? null;
    };

    const defaultDrgData = getDefaultDrg(drgData);
    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      origins: {
      principal_diagnosis: getOriginForCode(currentState?.principal?.[0]),
      additional_diagnoses: Object.fromEntries(
        (currentState?.additional || []).map(item => [
          item.code, 
          getOriginForCode(item)
        ])
      ),
      procedures: Object.fromEntries(
        (currentState?.procedure || []).map(item => [
          item.code, 
          getOriginForCode(item)
        ])
      )
    },
    module_name: moduleName,
      // queue_type:
      //   queueType === null
      //     ? null
      //     : (selectedQueueworkSpace?.queue_type ?? null),
      // queue_id:
      //   queueID === null ? null : (selectedQueueworkSpace?.queue_id ?? null),
      queue_type:
        queueType === null
          ? null
          : (queueType ?? selectedQueueworkSpace?.queue_type ?? null),
      queue_id:
        queueID === null
          ? null
          : (queueID ?? selectedQueueworkSpace?.queue_id ?? null),
      status: currentStatus,
      request_from:
        currentPage === "coderview" || currentPage === "episodeList"
          ? "U"
          : currentPage === "auditorPage"
            ? "AU"
            : "",
      drg_code: [defaultDrgData?.drg],
      drg_weight: [defaultDrgData?.weight],
      line_assignment_id: Number(sessionStorage.getItem("lineAssignmentId")) || line_assignment_id || "",
      icu_hours:
        data1?.data?.meta?.icu_hours == null
          ? 0
          : Number(data1?.data?.meta.icu_hours),
      hmv_hours: Number.isNaN(parseInt(mvHours, 10))
        ? 0
        : parseInt(mvHours, 10),
      niv_hours: Number.isNaN(parseInt(nivHours, 10)) 
        ? 0 
        : parseInt(nivHours, 10),
      is_confirmed: true,
      grouper_versions: [drgData?.grouper_versions[0]],
      cdq_request: cdqRequest ?? null,
      //          meta: {
      //   audit_queue_assignment: selectedQueueIds || [],
      //    assigned_user_id_for_review: [],

      //   assigned_user_id_for_audit: [
      //         {
      //           auditors: selectedAuditorId,
      //           audit_queues: selectedAuditorQueueIds || [],
      //         },
      //       ]
      //     ,
      // },
    };
    const principleClusterCodes = allPrincipalCodes?.map((val) => val) || [];
    const additionalClusterCodes = allAdditionalCodes?.map((val) => val) || [];
    const procedureClusterCodes = allProcedureCodes?.map((val) => val) || [];

    const allFinalClusterCodes = [
      ...principleClusterCodes,
      ...additionalClusterCodes,
      // ...procedureClusterCodes,
    ];
    const onlyAdditionalClusterCodes = additionalClusterCodes?.filter(
      (item) => ["1", "2"].includes(item?.[1]) && item,
    );

    const onlyPrincipleClusterCodes = principleClusterCodes?.map((item) =>
      ["1", "2"].includes(item?.[1]) ? item?.slice(2) : item?.slice(1),
    );

    const clusterCodePayloadToSend = {
      principal_diagnosis: onlyPrincipleClusterCodes[0],
      // diagnosis_codes: onlyAdditionalClusterCodes,
      diagnosis_codes: [
        ...principleClusterCodes,
        ...onlyAdditionalClusterCodes,
      ],
    };
    // console.log(clusterCodePayloadToSend, procedureClusterCodes, "szdxfghjk");
    const hasPrincipal =
      typeof clusterCodePayloadToSend?.principal_diagnosis === "string" &&
      clusterCodePayloadToSend.principal_diagnosis.trim().length > 0;

    const hasProcedures = procedureClusterCodes.length > 0;

    const hasDiagnosisCodes =
      Array.isArray(clusterCodePayloadToSend?.diagnosis_codes) &&
      clusterCodePayloadToSend.diagnosis_codes.some((code) => code?.code);

    if (!hasPrincipal && hasProcedures) {
      toast.error("Principal diagnosis is mandatory");
      return;
    }

    if (!hasPrincipal && !hasProcedures && !hasDiagnosisCodes) {
      toast.error("No codes present to confirm DRG");
      return;
    }

    let clusterCodesAPIData = [];
    let cancerCodesAPIData = [];

    const cancerCodesToSend = {
      diagnosis_codes: additionalClusterCodes?.map((item) =>
        ["1", "2"].includes(item?.[1]) ? item?.slice(2) : item?.slice(1),
      ),
      principal_diagnosis: principleClusterCodes?.map((item) =>
        ["1", "2"].includes(item?.[1]) ? item?.slice(2) : item?.slice(1),
      ),
      hcp_line_id: lastHcpLineId,
      role:
        currentPage === "coderview" || currentPage === "episodeList"
          ? "U"
          : currentPage === "auditorPage"
            ? "AU"
            : "",
    };

    if (
      clusterCodePayloadToSend?.principal_diagnosis?.length > 0 ||
      clusterCodePayloadToSend?.diagnosis_codes?.length > 0
    ) {
      if (!codebookusaEnv && data1?.data?.meta?.is_DCID === true) {
        const clusterResult = await dispatch(
          fetchClusterWarnings(clusterCodePayloadToSend),
        ).unwrap();

        const { warnings, errors } = clusterResult || {};
        clusterCodesAPIData = warnings || [];

        if (clusterCodesAPIData?.length > 0 || errors?.length > 0) {
          setWarningModal(true);
          if (cancerCodesAPIData.length > 0) {
            setCancerWarningModal(true);
          }
        }
      }
    }

    if (
      cancerCodesToSend?.principal_diagnosis?.length > 0 ||
      cancerCodesToSend?.diagnosis_codes?.length > 0
    ) {
      const result = await dispatch(
        fetchCodeAssistCancerWarnings(cancerCodesToSend),
      ).unwrap();

      const { info_warnings } = result || {};
      cancerCodesAPIData = info_warnings || [];

      if (cancerCodesAPIData?.length > 0) {
        setCancerWarningModal(true);
        // After closing cancer warning → show cluster warnings
        if (clusterCodesAPIData.length > 0) {
          setWarningModal(true);
        }
      }
    }

    if (clusterCodesAPIData.length === 0) {
      setdrgConfirmedStatusUpdate(true);
      acceptCode(payload, location.pathname)
        .then((res) => {
           if (res.status === 200) {
            sessionStorage.setItem("isConfirmed", true);
            isActionPerformed = true;
            setActionPerformed(true);
          }else{
            setActionPerformed(false);
          }
          if (data1.data.principal_diagnosis[0].code === null) {
            // toast.error(
            //   "DRG cannot be confirmed without principal diagnosis"
            // );
            // setIsDrgConfirmed(false);
          } else {
            // toast.success("DRG Confirmed Successfully");
            // setIsDrgConfirmed(true);
            if (typeOfPatient === "outPatient") {
              // console.log(typeOfPatient, "ggggg");
              toast.success("Save codes Successfully");
              setIsDrgConfirmed(true);
            } else {
              // console.log("Hello");
              toast.success("DRG Confirmed Successfully");
              setIsDrgConfirmed(true);
            }
          }
          setIsStatusUpdated(true);
          setIsCalculatingDrg(true);
        })
        .catch((err) => {
          setActionPerformed(false);
          toast.error(
            err.response.data.message || "Error occured while confirming DRG",
          );
        })
        .finally(() => {
          setdrgConfirmedStatusUpdate(false);
          setAuditedStatus(false);
        })
        .finally(() => {
          setdrgConfirmedStatusUpdate(false);
           if (isSessionStarted) {
            stopcoderSessionTimeCalculated();
          }
              const nudgingSessionPayload = {
                hcp_line_id: lastHcpLineId,
                is_confirmed: true,
                session_token:nudgingSessionResponseData?.data?.nudging_session_token ,
              };
              const nudgingSessionAPIResponse =  dispatch(
                nudgingSessionAPI(nudgingSessionPayload),
              ).then(()=>{
                  sessionStorage.removeItem("nudging_session_id");
                  sessionStorage.removeItem("nudging_session_token");
              })
          // setActionPerformed(false);
          setAuditedStatus(false);
          setIsDrgConfirmed(false);
          setTimeout(async () => {
            try {
              await fetchData1();
            } catch (err) {
              console.error(err);
            } finally {
              setIsStatusUpdated(false);
              setIsCalculatingDrg(false);
          calculate_drg(isActionPerformed);
          isActionPerformed=false;
          setActionPerformed(false);
            }
          }, 30000);
          // console.log(accepted, "accepted");

          // setAccepted({...accepted, [code]: false} );
          // sessionStorage.setItem("suppressCodebookFetch", "true");
          // window.location.reload();
          const currentScreen = sessionStorage.getItem("currentPage");
          const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
          let newEpisodeRecord = null;
          const newEpisodeListFilterObj = JSON.parse(
            sessionStorage.getItem("filters"),
          );
          if (
            location.pathname === "/coder" ||
            location.pathname === "/Code-Assist"
          ) {
            const payload = {
              ...episodeListFilterObj,
              status: ["Coding Complete"], // override only for payload
            };

            // console.log('yes its executing eplist block');
            // dispatch(getFilterEpisodeLists(payload)).then((res) => {
            //   console.log(res, "drgclickres");

            //   const newEpisodeRecord = res.payload?.episode?.find(
            //     (episode) => episode?.hcp_line_id === Number(hcpLineId),
            //   );

            //   if (newEpisodeRecord) {
            //     dispatch(selectedEpisodeList(newEpisodeRecord));
            //   }
            // });
          } else if (
            location.pathname === "/Auditor-Coding-Screen" ||
            location.pathname === "/Auditor-CodeAssist-Screen"
          ) {
            // console.log('yes its executing coder block');
            const payload = {
              ...newEpisodeListFilterObj,
              status: ["Audited"], // override only for payload
            };
            // dispatch(getFilterEpisodeLists(payload)).then((res) => {
            //   console.log(res, "drgclickres");

            //   const newEpisodeRecord = res.payload?.episode?.find(
            //     (episode) => episode?.hcp_line_id === Number(hcpLineId),
            //   );

            //   if (newEpisodeRecord) {
            //     dispatch(selectedEpisodeList(newEpisodeRecord));
            //   }
            // });
          } else if (currentScreen === "auditorPage") {
            // console.log("yes its executing audiot block");
            // dispatch(getFilterEpisodeLists(episodeListFilterObj)).then(
            //   (res) => {
            //     const newEpisodeRecord = res.payload?.episode?.find(
            //       (episode) => episode?.hcp_line_id === Number(hcpLineId),
            //     );
            //     if (newEpisodeRecord) {
            //       dispatch(selectedEpisodeList(newEpisodeRecord));
            //     }
            //     sessionStorage.setItem("episode-status-modal", "true");
            //     setOpenStatusUpdatedModal(true);
            //   },
            // );
          }
        });
    }

    // }
  };
const fetchNudgingData = async (
  stateOverride,
  drgOverride,
  weightOverride,
  grouperVersionOverride,
) => {
  const currentState = stateOverride ?? diagnosisStates;
  const drgToSend = drgOverride ?? selectedDrgData?.drg;
  const weightToSend = weightOverride ?? selectedDrgData?.weight;
  const grouperVersionToSend = grouperVersionOverride ?? drgSelectedVersion;

  // Check if we should skip (allow 0 and "can't determine")
  if (!drgToSend || weightToSend === undefined || weightToSend === null) {
    console.log("Skipping nudging: no valid DRG/weight yet");
    return;
  }

  // Prepare session payload
  const nudgingSessionPayload = {
    hcp_line_id: lastHcpLineId,
    is_confirmed: false,
    session_token: "",
  };

  console.log("Nudging session payload:", nudgingSessionPayload);
  console.log("Nudging session exists:", nudgeSessionExists);

  let sessionId = null;
  let sessionToken = null;

  try {
    // Check if session already exists in sessionStorage
    const existingSessionId = sessionStorage.getItem("nudging_session_id");
    const existingSessionToken = sessionStorage.getItem("nudging_session_token");

    if (existingSessionId && nudgeSessionExists) {
      // Use existing session
      console.log("Using existing nudging session:", existingSessionId);
      sessionId = existingSessionId;
      sessionToken = existingSessionToken?existingSessionToken:"";
    } else {
      // Create new session
      const nudgingSessionAPIResponse = await dispatch(
        nudgingSessionAPI(nudgingSessionPayload),
      );
      
      console.log("Nudging session API response:", nudgingSessionAPIResponse);

      sessionId = nudgingSessionAPIResponse?.payload?.data?.nudging_session_id;
      sessionToken = nudgingSessionAPIResponse?.payload?.data?.nudging_session_token;
      
      if (sessionId) {
        sessionStorage.setItem("nudging_session_id", sessionId);
        sessionStorage.setItem("nudging_session_token", sessionToken || "");
      }
    }

    if (!sessionId) {
      console.log("No nudging session ID available");
      return;
    }

    // Prepare evaluation payload (ALWAYS called, even if session existed)
    const normalizeCode = (code = "") =>
  ["1", "2"].includes(code?.[1])
    ? code?.slice(2)
    : code?.slice(1);

const principalDiagnosisCode = normalizeCode(currentState?.principal?.[0]?.code) || "";

const allAdditionalCodes =
  currentState?.additional?.map((item) => normalizeCode(item?.code)) || [];

const allProcedureCodes = currentState?.procedure?.map((item) => item?.code) || [];
     
    const nudgingEvaluationPayload = {
      nudging_session_id: sessionId,
      hcp_line_id: lastHcpLineId,
      module_name:
        location.pathname === "/Code-Assist" ||
        location.pathname === "/Auditor-CodeAssist-Screen"
          ? "Code Assist"
          : "Code Accelerate",
      principal_diagnosis_code: principalDiagnosisCode,
      additional_diagnosis: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      drg_code: drgToSend,
      weight: weightToSend,
      grouper_version_id: grouperVersionToSend,
    };

    console.log("Nudging evaluation payload:", nudgingEvaluationPayload);

    // ALWAYS call evaluation API
    await dispatch(nudgingEvaluationAPI(nudgingEvaluationPayload));
    
    console.log("Nudging evaluation completed successfully");

  } catch (error) {
    console.error("Nudging API error:", error);
  }
};

  // }
  const handleConfirmDrgUSA = () => {
    setNewlyInsertedCodes([]);
    setDeletedCodes([]);
    // console.log("entered drg");
    setdrgConfirmedStatusUpdate(true);
    setAuditedStatus(true);
    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code,
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code,
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code,
    );
    const hasValidPrincipalCode =
      Array.isArray(allPrincipalCodes) &&
      allPrincipalCodes.some((code) => code !== null);

    if (!hasValidPrincipalCode && allProcedureCodes.length > 0) {
      toast.error("Principal diagnosis code is required");
      setdrgConfirmedStatusUpdate(false);

      return;
    }

    if (
      !hasValidPrincipalCode &&
      allProcedureCodes.length === 0 &&
      allAdditionalCodes.length === 0
    ) {
      toast.error("No codes present to confirm drg");
      setdrgConfirmedStatusUpdate(false);

      return;
    }

    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      drg_code: [selectedDrgData?.drg],
      drg_weight: [selectedDrgData?.weight],
      line_assignment_id: Number(sessionStorage.getItem("lineAssignmentId")) || line_assignment_id || "",
      // queue_type:
      //   queueType === null
      //     ? null
      //     : (selectedQueueworkSpace?.queue_type ?? null),

      // queue_id:
      //   queueID === null ? null : (selectedQueueworkSpace?.queue_id ?? null),
      queue_type:
        queueType === null
          ? null
          : (queueType ?? selectedQueueworkSpace?.queue_type ?? null),
      queue_id:
        queueID === null
          ? null
          : (queueID ?? selectedQueueworkSpace?.queue_id ?? null),
      icu_hours:
        data1?.data?.meta?.icu_hours == null
          ? 0
          : Number(data1?.data?.meta.icu_hours),
      hmv_hours: Number.isNaN(parseInt(mvHours, 10))
        ? 0
        : parseInt(mvHours, 10),
      niv_hours: Number.isNaN(parseInt(nivHours, 10)) 
        ? 0 
        : parseInt(nivHours, 10),

      is_confirmed: true,
      grouper_versions: [drgSelectedVersion],
     cdq_request: cdqRequest ?? null,
      //      meta: {
      //   audit_queue_assignment: selectedQueueIds || [],
      //    assigned_user_id_for_review: [],

      //   assigned_user_id_for_audit: [
      //         {
      //           auditors: selectedAuditorId,
      //           audit_queues: selectedAuditorQueueIds || [],
      //         },
      //       ]
      //     ,
      // },
    };

    acceptCode(payload, location.pathname)
      .then((res) => {
        if (typeOfPatient === "outPatient") {
          // console.log(typeOfPatient, "ggggg");
          toast.success("Save codes Successfully");
          setIsDrgConfirmed(true);
        } else {
          // console.log("Hello, jyo1");
          toast.success("DRG Confirmed Successfully");
          setIsDrgConfirmed(true);
        }
      })
      .catch((err) => {
        toast.error(
          err.response.data.message || "Error occured while confirming DRG",
        );
      })
      .finally(() => {
        setdrgConfirmedStatusUpdate(false);
        setAuditedStatus(false);
      })
      .finally(() => {
        setdrgConfirmedStatusUpdate(false);
        setAuditedStatus(false);
        setIsDrgConfirmed(false);
        setTimeout(() => {
          // setDiagnosisStates(diagnosisStates);
          fetchData1();
        }, 200);
        // console.log(accepted, "accepted");

        // // setAccepted({...accepted, [code]: false} );
        // // sessionStorage.setItem("suppressCodebookFetch", "true");
        // // window.location.reload();
        // const currentScreen = sessionStorage.getItem("currentPage");
        // const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
        // let newEpisodeRecord = null;
        // const newEpisodeListFilterObj = JSON.parse(
        //   sessionStorage.getItem("filters")
        // );
        // if (
        //   location.pathname === "/coder" ||
        //   location.pathname === "/Code-Assist"
        // ) {
        //   const payload = {
        //     ...episodeListFilterObj,
        //     status: ["Coding Complete"], // override only for payload
        //   };

        //   // console.log('yes its executing eplist block');
        //   dispatch(getFilterEpisodeLists(payload)).then((res) => {
        //     console.log(res, "drgclickres");

        //     const newEpisodeRecord = res.payload?.episode?.find(
        //       (episode) => episode?.hcp_line_id === Number(hcpLineId)
        //     );

        //     if (newEpisodeRecord) {
        //       dispatch(selectedEpisodeList(newEpisodeRecord));
        //     }
        //   });
        // } else if (
        //   location.pathname === "/Auditor-Coding-Screen" ||
        //   location.pathname === "/Auditor-CodeAssist-Screen"
        // ) {
        //   // console.log('yes its executing coder block');
        //   const payload = {
        //     ...newEpisodeListFilterObj,
        //     status: ["Audited"], // override only for payload
        //   };
        //   dispatch(getFilterEpisodeLists(payload)).then((res) => {
        //     console.log(res, "drgclickres");

        //     const newEpisodeRecord = res.payload?.episode?.find(
        //       (episode) => episode?.hcp_line_id === Number(hcpLineId)
        //     );

        //     if (newEpisodeRecord) {
        //       dispatch(selectedEpisodeList(newEpisodeRecord));
        //     }
        //   });
        // } else if (currentScreen === "auditorPage") {
        //   console.log("yes its executing audiot block");
        //   dispatch(getFilterEpisodeLists(episodeListFilterObj)).then((res) => {
        //     const newEpisodeRecord = res.payload?.episode?.find(
        //       (episode) => episode?.hcp_line_id === Number(hcpLineId)
        //     );

        //     if (newEpisodeRecord) {
        //       dispatch(selectedEpisodeList(newEpisodeRecord));
        //     }
        //     sessionStorage.setItem("episode-status-modal", "true");
        //     setOpenStatusUpdatedModal(true);
        //   });
        // }

        // console.log(newEpisodeRecord, episodesFilterList, "newEpisodeRecord");
        // dispatch(selectedEpisodeList(episodeSelected));
      });
  };
  const handleMvhoursupdation = (e) => {
    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code,
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code,
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code,
    );
    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      // queue_type:
      //   queueType === null
      //     ? null
      //     : (selectedQueueworkSpace?.queue_type ?? null),

      // queue_id:
      //   queueID === null ? null : (selectedQueueworkSpace?.queue_id ?? null),
      queue_type:
        queueType === null
          ? null
          : (queueType ?? selectedQueueworkSpace?.queue_type ?? null),
      queue_id:
        queueID === null
          ? null
          : (queueID ?? selectedQueueworkSpace?.queue_id ?? null),
      status: currentStatus,
      icu_hours:
        data1?.data?.meta?.icu_hours == null
          ? 0
          : Number(data1?.data?.meta.icu_hours),
      hmv_hours: Number.isNaN(parseInt(mvHours, 10))
        ? 0
        : parseInt(mvHours, 10),
      niv_hours: Number.isNaN(parseInt(nivHours, 10))
        ? 0
        : parseInt(nivHours, 10),
      request_from:
        currentPage === "coderview" || currentPage === "episodeList"
          ? "U"
          : currentPage === "auditorPage"
            ? "AU"
            : "",
      drg_code: [selectedDrgData?.drg],
      drg_weight: [selectedDrgData?.weight],
      line_assignment_id: Number(sessionStorage.getItem("lineAssignmentId")) || line_assignment_id || "",
      icu_hours:
        data1?.data?.meta?.icu_hours == null
          ? 0
          : Number(data1?.data?.meta.icu_hours),
      hmv_hours: Number.isNaN(parseInt(mvHours, 10))
        ? 0
        : parseInt(mvHours, 10),
      niv_hours: Number.isNaN(parseInt(nivHours, 10)) 
        ? 0 
        : parseInt(nivHours, 10),
      is_confirmed: false,
      grouper_versions: [drgSelectedVersion],
      cdq_request: cdqRequest ?? null,
      //       meta: {
      //   audit_queue_assignment: selectedQueueIds || [],
      //    assigned_user_id_for_review: [],

      //   assigned_user_id_for_audit: [
      //         {
      //           auditors: selectedAuditorId,
      //           audit_queues: selectedAuditorQueueIds || [],
      //         },
      //       ]
      //     ,
      // },
    };
    if (e.key === "Enter") {
      acceptCode(payload, location.pathname)
        .then((res) => {
          if (res.status === 200) {
            toast.success("Successfully updated MV/NIV hours");
          }
        })
        .catch((err) => {
          toast.success("Error while updating");
        });
    }
  };
  const insertCode = async (code, description, type, warning, acs, nca,allowDuplicate = false) => {
    // if(isFromAccelerate) return;
    if (insertingCodes.has(code)) {
      // console.warn(`Skipping duplicate insertion for: ${code}`);
      return;
    }
    dispatch(setcurrentClusterID(nextClusterCurrentIndex));
    insertingCodes.add(code);
    return new Promise((resolve) => {
      setDiagnosisStates((prev) => {
        if (!allowDuplicate && prev[type].some((item) => item?.code === code)) {
          insertingCodes.delete(code);
          //console.warn(`Code already exists in ${type}, skipping: ${code}`);
          return prev;
        }
        const newCode = {
          code,
          description: description || `Description for ${code}`,
          warning,
          acs,
          nca,
        };
        const updatedState = {
          ...prev,
          [type]: type === "principal" ? [newCode] : [...prev[type], newCode],
        };
        sessionStorage.setItem(
          `${type}DiagnosisState`,
          JSON.stringify(updatedState[type]),
        );
        return updatedState;
      });
      setTimeout(() => {
        // setDiagnosisStates((updatedState) => {
        //   handleAccept(
        //     code,
        //     { code, description, warning, acs, nca },
        //     type,
        //     updatedState,
        //   )
        //     .then(() => insertingCodes.delete(code))
        //     .catch(() => insertingCodes.delete(code));
        //   return updatedState;
        // });
        resolve();
      }, 0);
    });
  };
  const validateCodeAPI = async (code, type) => {
    const cleanedCode = code?.replace(/[()]/g, "");
    // console.log(type, codebookdevEnv, "mhsgcjhs");
    const originalType = type;
    if (type === "additional" || type === "principal") {
      type = "ICD";
    } else {
      type =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanhcEnv ||
        codebooksanprodEnv ||
        codebookhealthecareEnv||
        pallasaiTestCodebookEnv
          ? "ACHI"
          : codebookusaEnv
            ? "CPT"
            : "";
    }
    const url = "/checkIfCodeExists";
    const payload = {
      u_agey: data1?.data?.meta?.age_y,
      u_aged: data1?.data?.meta?.age_d,
      sex: data1?.data?.meta?.sex,
      code: cleanedCode,
      check_for: type,
      check_type: originalType === "principal" ? "PDX" : "",
    };
    try {
      const response = await axiosInstance.post(url, payload);
      if (response.status === 200) {
        return {
          valid: response.data.code_exists,
          validCode: response.data.canonical_code || "",
          description: response.data.description || "",
          // isWarning: response.data.is_warning || false,
          // warningDescription: response.data.warning_description || "",
          // isPopup: response.data.should_popup,
          acs: response.data.acs || null,
          nca: response.data.nca || null,
        };
      }
    } catch (error) {
      console.error("Error validating code", error);
    }
    return {
      valid: false,
      validCode: "",
      description: "",
      // isWarning: false,
      // warningDescription: "",
      // isPopup: "",
      acs: null,
      nca: null,
    };
  };

  const checkTypeOfCode = (code) => {
    if (!code) return "";

    const removeFirstChar = code?.slice(1);
    let result = "";

    const injuryWithActivityCodes =
      injuryWithActivity?.map((v) => v?.name) ?? [];

    const externalCauseCodesList =
      externalCauseCodes?.map((v) => v?.name) ?? [];

    const placeOfOccurrenceCodes = placeOfOccurrence?.map((v) => v?.name) ?? [];

    const activityCodesList = activityCodes?.map((v) => v?.name) ?? [];

    const injuryWithoutActivityCodes =
      injuryWithoutActivity?.map((v) => v?.name) ?? [];

    const chronicCodesList = chronicCodes?.map((v) => v?.name) ?? [];

    const allNonChronicGroups = [
      injuryWithActivityCodes,
      externalCauseCodesList,
      placeOfOccurrenceCodes,
      activityCodesList,
      injuryWithoutActivityCodes,
    ];

    const isNonChronic = allNonChronicGroups.some((list) =>
      list.includes(code),
    );

    if (isNonChronic) {
      result = `${currentClusterID}${code}`;
    } else if (chronicCodesList.includes(code)) {
      result = `0${code}`;
    } else {
      result = `8${code}`;
    }

    return result;
  };
  const isCodeInAchiList = (code) => {
      if (typeof code !== "string") return false;
      const exists = achiCodesData.achiCodes.includes(code.trim()); 
      // console.log("Checking ACHI:", code, "Exists:", exists);
      return exists;
    };
  const handleCodeAssistAddingUSA = async (draggedData, isRootCall = true) => {
    let toastId;

    if (isRootCall) {
      // Show a single "loading" toast only for root call
      toastId = toast.loading("Adding codes, please wait...");
      setSkipAcceptApi(true);
      setAuditedStatus(true);
    }

    try {
      const parsedData = JSON.parse(draggedData);

      // Check if draggedData is in new format
      const isNewFormat =
        parsedData.hasOwnProperty("Principal Diagnosis") ||
        parsedData.hasOwnProperty("Additional Diagnoses") ||
        parsedData.hasOwnProperty("Procedure Diagnosis");

      if (isNewFormat) {
        const sectionMap = {
          "Principal Diagnosis": "principal",
          "Additional Diagnoses": "additional",
          "Procedure Codes": "procedure",
        };

        for (const [key, type] of Object.entries(sectionMap)) {
          const entries = parsedData[key] || [];

          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const codesToInsert = entry.codes || [];

            // special handling for Principal Diagnosis array
            let resolvedType = type;

            if (key === "Principal Diagnosis") {
              resolvedType = i === 0 ? "principal" : "additional";
            }

            const fakeDraggedData = JSON.stringify({
              tab:
                resolvedType === "principal"
                  ? "Principal diagnosis"
                  : resolvedType === "additional"
                    ? "ICD 10 AM Index"
                    : "ACHI Tab",
              codes: codesToInsert,
            });

            await handleCodeAssistAddingUSA(fakeDraggedData, false);
          }
        }

        if (isRootCall) {
          // all recursive inserts finished → update toast
          toast.update(toastId, {
            render: "All codes inserted successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }
        return;
      }

      let type;

      if (parsedData.tab === "ICD 10 AM Index") {
        type = "additional";
      } else if (parsedData.tab === "Principal diagnosis") {
        type = "principal";
      } else {
        type = "procedure";
      }

      const { codes, tab } = parsedData;
      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        if (isRootCall) {
          toast.update(toastId, {
            render: "Invalid codes!",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
        return;
      }

      const existingCodes = new Set([
        ...diagnosisStates["principal"].map(
          (item) => item?.code,
          // ?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["additional"].map(
          (item) => item?.code,
          // ?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["procedure"].map(
          (item) => item?.code,
          // ?.replace(/^[12]/, "")
        ),
      ]);

      const isICD = tab.includes("ICD 10 AM");
      const isACHI = tab.includes("ACHI");
      if (
        (type === "procedure" && isICD) ||
        ((type === "additional" || type === "principal") && isACHI)
      ) {
        toast.warning(
          `${
            isICD ? "ICD" : "ACHI"
          } codes can't be inserted in ${type.toUpperCase()} section`,
        );
        return;
      }

      let extractedCodesArray = [];
      codes.forEach((code) => {
        code = code.trim();
        if (!code) return;

        const match = code.match(/^\(([^)]+)\)(.+)$/);
        if (match) {
          extractedCodesArray.push(match[2].trim());
          extractedCodesArray.push(match[1].trim());
        } else {
          extractedCodesArray.push(code);
        }
      });

      let principalCode = extractedCodesArray[0];
      let additionalCodes = extractedCodesArray.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];
      // const removeFirstChar = (codeSet) => {
      //   return new Set(
      //     [...codeSet].map((code) => {
      //       return  ["1", "2"]?.includes(code[1]) ? code?.slice(2) : code?.slice(1);
      //     })
      //   );
      // };

      const removeLeadingDigits = (codeSet) => {
        return new Set(
          [...codeSet]
            ?.filter((c) => typeof c === "string" && c?.length > 0)
            ?.map((code) => {
              if (/^[A-Za-z]/.test(code)) {
                return code;
              }
              return code?.replace(/^\d+/, "");
            }),
        );
      };
      const cleanUPCodes = removeLeadingDigits(existingCodes);
      // let duplicateCodes = extractedCodesArray.filter((code) =>
      //   cleanUPCodes.has(code.replace(/^[12]/, ""))
      // );

      let duplicateCodes = extractedCodesArray?.filter((code) => {
        if (typeof code !== "string" || code?.length === 0) return false;

        const isDuplicate = cleanUPCodes?.has(code);

        return isDuplicate;
      });

      let uniqueNewCodes = extractedCodesArray.filter(
        (code) => !cleanUPCodes.has(code),
      );

      if (duplicateCodes.length > 0) {
        toast.warning(
          `Duplicate code${
            duplicateCodes.length > 1 ? "s" : ""
          } found: ${duplicateCodes
            .map((code) => code.replace(/^[12]/, ""))
            .join(", ")}`,
        );
      }

      if (uniqueNewCodes.length === 0) {
        return; // No new codes to insert
      }

      let newPrincipalWarnings = [];
      let newAdditionalWarnings = [];
      let popupWarnings = [];

      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
                ? "procedure"
                : "additional";

          const {
            valid,
            description,
            isWarning,
            warningDescription,
            isPopup,
            acs,
          } = await validateCodeAPI(extractedCode, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              newPrincipalWarnings.push(warningDescription);
            } else {
              newAdditionalWarnings.push(warningDescription);
            }
          }

          if (isPopup) {
            popupWarnings.push({
              code: extractedCode,
              message: warningDescription,
            });
          }

          return {
            code: extractedCode,
            description,
            warning,
            validationType,
            acs,
          };
        }),
      );

      const finalValidCodes = validationResults.filter(Boolean);
      if (finalValidCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }
      const removeFirstChar = (codeSet) => {
        const newSet = new Set();
        for (const code of codeSet) {
          if (typeof code === "string" && code.length > 1) {
            newSet.add(code.slice(1));
          }
        }
        return newSet;
      };

      const cleanUPCodesWithoutFirstChar = removeFirstChar(cleanUPCodes);

      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
        const normalizedCode = code.replace(/^[12]/, "");
        if (cleanUPCodesWithoutFirstChar.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (nonDuplicateValidCodes.length === 0) {
        // toast.warning("Codes already exist!");
        return;
      }

      await Promise.all(
        nonDuplicateValidCodes.map(
          ({ code, description, warning, validationType, acs }) => {
            const resultCode = checkTypeOfCode(code);
            insertCode(
              validationType !== "procedure" && !codebookusaEnv
                ? `${resultCode?.charAt(0)}Y${code}`
                : validationType !== "procedure" && codebookusaEnv
                  ? `Y${code}`
                  : code,
              description,
              validationType,
              warning,
              acs,
            );
          },
        ),
      );

      setIconDispaly(true);
      saveToHistory();
      setDiagnosisStates((prevStates) => {
        let updatedStates = { ...prevStates };

        if (type === "principal") {
          const prevPrincipal = prevStates["principal"][0];
          const existingAdditional = prevStates["additional"];
          // Find the new principal code entry from nonDuplicateValidCodes
          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, ""),
          );

          const associatedAdditionalCodes = extractedCodesArray.slice(1);

          let additionalToPrepend = [];

          associatedAdditionalCodes.forEach((code) => {
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyInAdditional = existingAdditional.some(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode,
            );
            const foundEntry = nonDuplicateValidCodes.find(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode,
            );

            if (!alreadyInAdditional && foundEntry) {
              const resultCode = checkTypeOfCode(foundEntry?.code);
              additionalToPrepend.push({
                ...foundEntry,
                code: !codebookusaEnv
                  ? `${resultCode?.charAt(0)}Y${foundEntry.code.replace(
                      /^[12]/,
                      "",
                    )}`
                  : `Y${foundEntry.code.replace(/^[12]/, "")}`,
                acs: foundEntry.acs,
              });
            }
          });
          // Move previous principal to additional if not already there
          // Move previous principal to additional ONLY if a valid principal already existed
          // Move previous principal ONLY if one existed before this insert
          const hadPrincipalBeforeInsert =
            Array.isArray(diagnosisStates?.principal) &&
            diagnosisStates.principal.length > 0 &&
            diagnosisStates.principal[0]?.code;

          if (
            hadPrincipalBeforeInsert &&
            prevPrincipal &&
            typeof prevPrincipal.code === "string" &&
            prevPrincipal.code.trim().length > 0 &&
            prevPrincipal.code.replace(/^[12]/, "") !==
              principalEntry?.code?.replace(/^[12]/, "") &&
            !existingAdditional.some(
              (item) =>
                item.code.replace(/^[12]/, "") ===
                prevPrincipal.code.replace(/^[12]/, ""),
            )
          ) {
            const resultCode = checkTypeOfCode(prevPrincipal.code);

            const movedPrincipal = {
              ...prevPrincipal,
              code: !codebookusaEnv
                ? `${resultCode?.charAt(0)}Y${prevPrincipal.code.replace(
                    /^[12]/,
                    "",
                  )}`
                : `Y${prevPrincipal.code.replace(/^[12]/, "")}`,
            };

            additionalToPrepend.push(movedPrincipal);

            insertCode(
              movedPrincipal.code,
              movedPrincipal.description,
              "additional",
              movedPrincipal.warning,
              movedPrincipal.acs,
            );
          }

          const filteredAdditional = existingAdditional.filter(
            (item) =>
              !additionalToPrepend.some(
                (prepended) =>
                  prepended.code.replace(/^[12]/, "") ===
                  item.code.replace(/^[12]/, ""),
              ),
          );

          if (principalEntry) {
            const resultCode = checkTypeOfCode(principalEntry.code);
            updatedStates["principal"] = [
              {
                ...principalEntry,
                code: !codebookusaEnv
                  ? `${resultCode?.charAt(0)}Y${principalEntry.code.replace(
                      /^[12]/,
                      "",
                    )}`
                  : `Y${principalEntry.code.replace(/^[12]/, "")}`,
                acs: principalEntry.acs,
              },
            ];
          }

          updatedStates["additional"] = [
            ...additionalToPrepend,
            ...filteredAdditional,
          ];
        }

        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];

        const filteredPrincipalWarnings = newPrincipalWarnings.filter(
          (warning) =>
            !popupWarnings.some((popup) => popup.message === warning),
        );

        const filteredAdditionalWarnings = newAdditionalWarnings.filter(
          (warning) =>
            !popupWarnings.some((popup) => popup.message === warning),
        );

        if (filteredPrincipalWarnings.length > 0) {
          updatedWarnings = [
            filteredPrincipalWarnings[0],
            ...updatedWarnings.filter(
              (w) => w !== filteredPrincipalWarnings[0],
            ),
          ];
        }

        filteredAdditionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);

      const lastInsertedCode =
        nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
      const popupWarning = popupWarnings.find(
        (w) => w.code === lastInsertedCode,
      );
      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.message);
        setModalVisible(true);
      }

      // success toast only once (root)
      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "All codes inserted successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error handling drop:", error);

      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "Failed to insert some codes.",
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      }
    } finally {
      if (isRootCall) {
        setAuditedStatus(false);

        try {
          //  Keep the toast visible until fetchData1 completes
          if (toastId) {
            toast.update(toastId, {
              render: "Finalizing data, please wait...",
              type: "info",
              isLoading: true,
              autoClose: false,
            });
          }

          // Wait 50 seconds before calling fetchData1
          await new Promise((resolve) => setTimeout(resolve, 1000));

          // Then call fetchData1
          // await fetchData1();

          // Once fetchData1 completes, show success toast
          if (toastId) {
            toast.update(toastId, {
              render: "Codes are added successfully!",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.error("Error during delayed fetchData1:", error);
          if (toastId) {
            toast.update(toastId, {
              render: "Failed to refresh data after adding codes.",
              type: "error",
              isLoading: false,
              autoClose: 4000,
            });
          }
        } finally {
          setIsFetchingData1(false);

          const newEpisodeListFilterObj = sessionStorage.getItem("filters");
          const hcpLineId = sessionStorage.getItem("last_hcp_line_id");

          dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then(
            (res) => {
              const newEpisodeRecord = res.payload?.episode?.find(
                (episode) => episode?.hcp_line_id === Number(hcpLineId),
              );

              if (newEpisodeRecord) {
                dispatch(selectedEpisodeList(newEpisodeRecord));
              }
            },
          );
          const principleClusterCodes =
            diagnosisStates?.principal?.map((val) => val.code) || [];
          const additionalClusterCodes =
            diagnosisStates?.additional?.map((val) => val.code) || [];
          const procedureClusterCodes =
            diagnosisStates?.procedure?.map((val) => val.code) || [];

          const allFinalClusterCodes = [
            ...principleClusterCodes,
            ...additionalClusterCodes,
            // ...procedureClusterCodes,
          ];
          const onlyAdditionalClusterCodes = additionalClusterCodes?.filter(
            (item) => ["1", "2"].includes(item?.[1]) && item,
          );

          const onlyPrincipleClusterCodes = principleClusterCodes
            ?.filter((item) => typeof item === "string" && item.length > 0)
            .map((item) =>
              ["1", "2"].includes(item[1]) ? item.slice(2) : item.slice(1),
            );

          const clusterCodePayloadToSend = {
            principal_diagnosis: onlyPrincipleClusterCodes[0],
            diagnosis_codes: onlyAdditionalClusterCodes,
          };

          if (!codebookusaEnv) {
            if (
              clusterCodePayloadToSend?.principal_diagnosis?.length > 0 ||
              clusterCodePayloadToSend?.diagnosis_codes?.length > 0
            ) {
              dispatch(fetchClusterWarnings(clusterCodePayloadToSend))
                .unwrap()
                .then((result) => {
                  const { warnings, errors } = result || [];

                  if (warnings?.length === 0 && errors?.length === 0) {
                    // toast.warning("No Warnings");
                  } else {
                    setWarningModal(true);
                  }
                })
                .catch((err) => {
                  console.log(
                    "Warning API failed → still calling acceptCode()",
                    err,
                  );
                });
            }
          }
        }
      }
    }
  };
  const handleCodeAssistAdding = async (draggedData, isRootCall = true) => {
    let toastId;

    if (isRootCall) {
      isBatchInsertingRef.current = true;
      toastId = toast.loading("Adding codes, please wait...");
      setSkipAcceptApi(true);
      setAuditedStatus(true);
    }

    try {
      const parsedData = JSON.parse(draggedData);

      const isNewFormat =
        parsedData.hasOwnProperty("Principal Diagnosis") ||
        parsedData.hasOwnProperty("Additional Diagnoses") ||
        parsedData.hasOwnProperty("Procedure Diagnosis");

      if (isNewFormat) {
        const sectionMap = {
          "Principal Diagnosis": "principal",
          "Additional Diagnoses": "additional",
          "Procedure Codes": "procedure",
        };

        for (const [key, type] of Object.entries(sectionMap)) {
          const entries = parsedData[key] || [];
          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const codesToInsert = entry.codes || [];
            let resolvedType = type;
            if (key === "Principal Diagnosis") {
              resolvedType = i === 0 ? "principal" : "additional";
            }
            const fakeDraggedData = JSON.stringify({
              tab:
                resolvedType === "principal"
                  ? "Principal diagnosis"
                  : resolvedType === "additional"
                    ? "ICD 10 AM Index"
                    : "ACHI Tab",
              codes: codesToInsert,
            });
            await handleCodeAssistAdding(fakeDraggedData, false);
          }
        }

        if (isRootCall) {
          toast.update(toastId, {
            render: "All codes inserted successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }
        setBatchInsertCompleted(true);
        return;
      }

      let type;
      if (parsedData.tab === "ICD 10 AM Index") {
        type = "additional";
      } else if (parsedData.tab === "Principal diagnosis") {
        type = "principal";
      } else {
        type = "procedure";
      }

      const { codes, tab } = parsedData;
      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        if (isRootCall) {
          toast.update(toastId, {
            render: "Invalid codes!",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
        return;
      }

      // ── Read current state snapshot once ──────────────────────────────────
      const currentState = diagnosisStatesRef.current;

      const existingCodes = new Set([
        ...currentState["principal"].map((item) => item?.code),
        ...currentState["additional"].map((item) => item?.code),
        ...currentState["procedure"].map((item) => item?.code),
      ]);

      const isICD = tab.includes("ICD 10 AM");
      const isACHI = tab.includes("ACHI");
      if (
        (type === "procedure" && isICD) ||
        ((type === "additional" || type === "principal") && isACHI)
      ) {
        toast.warning(
          `${isICD ? "ICD" : "ACHI"} codes can't be inserted in ${type.toUpperCase()} section`,
        );
        return;
      }

      let extractedCodesArray = [];
      codes.forEach((code) => {
        code = code.trim();
        if (!code) return;
        const match = code.match(/^\(([^)]+)\)(.+)$/);
        if (match) {
          extractedCodesArray.push(match[2].trim());
          extractedCodesArray.push(match[1].trim());
        } else {
          extractedCodesArray.push(code);
        }
      });

      const removeLeadingDigits = (codeSet,type) => {
        return new Set(
          [...codeSet]
            ?.filter((c) => typeof c === "string" && c?.length > 0)
            ?.map((code) => {
             if (type === "procedure") return code; 
              if (/^[A-Za-z]/.test(code)) return code;
              return code?.replace(/^\d+/, "");
            }),
        );
      };

      const cleanUPCodes = removeLeadingDigits(existingCodes,type);

      const duplicateCodes = extractedCodesArray?.filter((code) => {
        if (typeof code !== "string" || code?.length === 0) return false;
        
        if (type === "procedure" && !isCodeInAchiList(code)) {
          return false;
        }
        return cleanUPCodes?.has(code);
      });

      if (duplicateCodes.length > 0) {
        toast.warning(
          `Duplicate code${duplicateCodes.length > 1 ? "s" : ""} found: ${duplicateCodes
            .map((code) => code.replace(/^[12]/, ""))
            .join(", ")}`,
        );
      }

      // const uniqueNewCodes = extractedCodesArray.filter(
      //   (code) => !cleanUPCodes.has(code),
      // );
      const uniqueNewCodes = extractedCodesArray.filter((code) => {
        if (type === "procedure" && !isCodeInAchiList(code)) return true;
        return !cleanUPCodes.has(code);
      });
      if (uniqueNewCodes.length === 0) return;

      // ── Validate ALL codes in parallel — only ONE round of API calls ──────
      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const principalCode = extractedCodesArray[0];
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
                ? "procedure"
                : "additional";

          const { valid, description, acs, nca } = await validateCodeAPI(
            extractedCode,
            validationType,
          );

          if (!valid) return null;
          return { code: extractedCode, description, acs, nca, validationType };
        }),
      );

      const finalValidCodes = validationResults.filter(Boolean);
      if (finalValidCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }

      const removeFirstChar = (codeSet) => {
        const newSet = new Set();
        for (const code of codeSet) {
          if (typeof code === "string" && code.length > 1) {
            newSet.add(code.slice(1));
          }
        }
        return newSet;
      };
      const cleanUPCodesWithoutFirstChar = removeFirstChar(cleanUPCodes);

      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
           if (type === "procedure") {
          // Allow duplicates for non-ACHI codes
          if (!isCodeInAchiList(code)) {
            return true;
          }
        }
        const normalizedCode = code.replace(/^[12]/, "");
        if (cleanUPCodesWithoutFirstChar.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (nonDuplicateValidCodes.length === 0) return;

      // ── Build the new state in one shot — NO insertCode calls ─────────────
      const principalCode = extractedCodesArray[0];

      const buildPrefixedCode = (code, validationType) => {
        const resultCode = checkTypeOfCode(code);
        if (validationType === "procedure") return code;
        if (!codebookusaEnv) {
          return data1?.data?.meta?.is_DCID === true
            ? `${resultCode?.charAt(0)}2${code}`
            : `2${code}`;
        }
        return `2${code}`;
      };

      saveToHistory();

      // ── Single setDiagnosisStates call ────────────────────────────────────
      let finalNewState;
      setDiagnosisStates((prev) => {
        const updatedState = {
          principal: [...prev.principal],
          additional: [...prev.additional],
          procedure: [...prev.procedure],
        };

        if (type === "principal") {
          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, ""),
          );

          const prevPrincipal = prev.principal[0];
          const hadPrincipalBeforeInsert =
            Array.isArray(prev.principal) &&
            prev.principal.length > 0 &&
            prev.principal[0]?.code;

          // Collect additional codes from the dragged batch
          const additionalToPrepend = [];
          const associatedAdditionalCodes = extractedCodesArray.slice(1);

          associatedAdditionalCodes.forEach((code) => {
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyInAdditional = prev.additional.some(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode,
            );
            const foundEntry = nonDuplicateValidCodes.find(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode,
            );
            if (!alreadyInAdditional && foundEntry) {
              const prefixed = buildPrefixedCode(foundEntry.code, "additional");
              additionalToPrepend.push({
                code: prefixed,
                description: foundEntry.description,
                acs: foundEntry.acs,
                nca: foundEntry.nca,
                warning: null,
              });
            }
          });

          // Move previous principal to additional
          if (
            hadPrincipalBeforeInsert &&
            prevPrincipal &&
            typeof prevPrincipal.code === "string" &&
            prevPrincipal.code.trim().length > 0 &&
            prevPrincipal.code.replace(/^[12]/, "") !==
              principalEntry?.code?.replace(/^[12]/, "") &&
            !prev.additional.some(
              (item) =>
                item.code.replace(/^[12]/, "") ===
                prevPrincipal.code.replace(/^[12]/, ""),
            )
          ) {
            const resultCode = checkTypeOfCode(prevPrincipal.code);
            const movedCode = !codebookusaEnv
              ? data1?.data?.meta?.is_DCID === true
                ? `${resultCode?.charAt(0)}2${prevPrincipal.code.replace(/^[12]/, "")}`
                : `2${prevPrincipal.code.replace(/^[12]/, "")}`
              : `2${prevPrincipal.code.replace(/^[12]/, "")}`;

            additionalToPrepend.push({
              ...prevPrincipal,
              code: movedCode,
            });
          }

          const filteredAdditional = prev.additional.filter(
            (item) =>
              !additionalToPrepend.some(
                (prepended) =>
                  prepended.code.replace(/^[12]/, "") ===
                  item.code.replace(/^[12]/, ""),
              ),
          );

          if (principalEntry) {
            const prefixed = buildPrefixedCode(
              principalEntry.code,
              "principal",
            );
            updatedState.principal = [
              {
                code: prefixed,
                description: principalEntry.description,
                acs: principalEntry.acs,
                nca: principalEntry.nca,
                warning: null,
              },
            ];
          }

          updatedState.additional = [
            ...additionalToPrepend,
            ...filteredAdditional,
          ];
        } else if (type === "additional") {
          nonDuplicateValidCodes.forEach(({ code, description, acs, nca }) => {
            const prefixed = buildPrefixedCode(code, "additional");
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyExists = updatedState.additional.some(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode,
            );
            if (!alreadyExists) {
              updatedState.additional.push({
                code: prefixed,
                description,
                acs,
                nca,
                warning: null,
              });
            }
          });
        } else if (type === "procedure") {
          nonDuplicateValidCodes.forEach(({ code, description, acs, nca }) => {

    // Allow duplicates for non-ACHI procedure codes
    if (!isCodeInAchiList(code)) {
      updatedState.procedure.push({
        code,
        description,
        acs,
        nca,
        warning: null,
      });
      return;
    }

            const alreadyExists = updatedState.procedure.some(
              (item) => item.code === code,
            );
            if (!alreadyExists) {
              updatedState.procedure.push({
                code,
                description,
                acs,
                nca,
                warning: null,
              });
            }
          });
        }

        finalNewState = updatedState;
        return updatedState;
      });
      waitForUserActionRef.current = false;
      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);
      setIconDispaly(true);

      // ── One handleAccept call with the built state ─────────────────────────
      // Use a short delay to ensure setDiagnosisStates has committed
      await new Promise((resolve) => setTimeout(resolve, 0));
      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "All codes inserted successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      // console.error("Error handling drop:", error);
      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "Failed to insert some codes.",
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      }
    } finally {
      if (isRootCall) {
        setAuditedStatus(false);
        setSkipAcceptApi(false); // ← release the guard
        isBatchInsertingRef.current = false;

        try {
          if (toastId) {
            toast.update(toastId, {
              render: "Finalizing data, please wait...",
              type: "info",
              isLoading: true,
              autoClose: false,
            });
          }

          // await new Promise((resolve) => setTimeout(resolve, 3000));
          // await fetchData1();

          if (toastId) {
            toast.update(toastId, {
              render: "Codes are added successfully!",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });
          }
        } catch (error) {
          // console.error("Error during delayed fetchData1:", error);
          if (toastId) {
            toast.update(toastId, {
              render: "Failed to refresh data after adding codes.",
              type: "error",
              isLoading: false,
              autoClose: 4000,
            });
          }
        } finally {
          setIsFetchingData1(false);

          // const newEpisodeListFilterObj = JSON.parse(
          //   sessionStorage.getItem("filters"),
          // );
          // const hcpLineId = sessionStorage.getItem("last_hcp_line_id");

          // dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {
          //   const newEpisodeRecord = res.payload?.episode?.find(
          //     (episode) => episode?.hcp_line_id === Number(hcpLineId),
          //   );
          //   if (newEpisodeRecord) {
          //     dispatch(selectedEpisodeList(newEpisodeRecord));
          //   }
          // });

          // Cluster warnings (non-USA only)
          if (!codebookusaEnv && data1?.data?.meta?.is_DCID === true) {
            const state = diagnosisStatesRef.current;
            const principleClusterCodes =
              state?.principal?.map((v) => v.code) || [];
            const additionalClusterCodes =
              state?.additional?.map((v) => v.code) || [];

            const onlyAdditionalClusterCodes = additionalClusterCodes.filter(
              (item) => ["1", "2"].includes(item?.[1]) && item,
            );
            const onlyPrincipleClusterCodes = principleClusterCodes
              .filter((item) => typeof item === "string" && item.length > 0)
              .map((item) =>
                ["1", "2"].includes(item[1]) ? item.slice(2) : item.slice(1),
              );

            const clusterCodePayloadToSend = {
              principal_diagnosis: onlyPrincipleClusterCodes[0],
              diagnosis_codes: onlyAdditionalClusterCodes,
            };

            if (
              clusterCodePayloadToSend?.principal_diagnosis?.length > 0 ||
              clusterCodePayloadToSend?.diagnosis_codes?.length > 0
            ) {
              dispatch(fetchClusterWarnings(clusterCodePayloadToSend))
                .unwrap()
                .then((result) => {
                  const { warnings, errors } = result || {};
                  if (warnings?.length > 0 || errors?.length > 0) {
                    setWarningModal(true);
                  }
                })
                .catch((err) => console.log("Warning API failed", err));
            }
          }
        }
      }
    }
  };

  //   useEffect(() => {
  //   const principleClusterCodes = diagnosisStates?.principal?.map(val => val.code) || [];
  //   const additionalClusterCodes = diagnosisStates?.additional?.map(val => val.code) || [];
  //   const procedureClusterCodes = diagnosisStates?.procedure?.map(val => val.code) || [];

  //   const allFinalClusterCodes = [
  //     ...principleClusterCodes,
  //     ...additionalClusterCodes,
  //     ...procedureClusterCodes,
  //   ];

  //   if (allFinalClusterCodes.length > 0) {
  //     console.log("inside allFinalClusterCodes")
  //     dispatch(fetchClusterWarnings(allFinalClusterCodes));
  //   }
  // }, [diagnosisStates]);
  const handleSendToAudit = async (actionType = null, resetQueue = false) => {
    // Add actionType parameter
    // console.log("SEND CLICKED");

    // console.log(actionType, selectedAuditorId, selectedQueueIds, "actionTypesss");
    setSkipAcceptApi(true);
    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code,
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code,
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code,
    );
      // Determine default origin based on pathname
  const isCoderPath = ["/coder", "/Code-Assist"].includes(location.pathname);
  const isAuditorPath = ["/Auditor-Coding-Screen", "/Auditor-CodeAssist-Screen"].includes(location.pathname);
  const defaultOrigin = isCoderPath ? "U" : isAuditorPath ? "AU" : "U";
  const moduleName = (location.pathname === "/coder" || location.pathname === "/Auditor-Coding-Screen") ? "Code Accelerate" : "Code Assist";
  
  // Helper function to get origin for each code
  const getOriginForCode = (item) => {
    // If the item has an origin and it's not null, use it
    if (item?.origin && item.origin !== null) {
      return item.origin;
    }
    // Otherwise use the default origin based on pathname
    return defaultOrigin;
  };

    // const reasons = selectedMissingNotesOptions.reasons || [];
    const reasons =
      actionType === "missingNotes"
        ? selectedMissingNotesOptions.reasons || []
        : [];
    const comments = reasons.map((reason, index) =>
      reason === "Other (specify)"
        ? selectedMissingNotesOptions.additional_comments?.[index] || null
        : null,
    );

    // Determine status based on actionType
    let statusToSend;
    if (actionType === "awaitingCDQ") {
      statusToSend = "Awaiting CDQ Response";
    } else if (actionType === "Audited") {
      statusToSend = actionType;
    } else if (actionType === "On Hold" || actionType === "Audit - On Hold") {
      statusToSend = actionType;
    } else if (
      actionType !== "AuditForReview" &&
      (selectedQueueIds.length > 0 || selectedAuditorId)
    ) {
      statusToSend = "Awaiting Audit";
    } else if (
      actionType === "AuditForReview" ||
      coderForReviewId ||
      auditorForReviewId
    ) {
      statusToSend =
        currentPage === "auditorPage" ? "Audit - For Review" : "For Review";
    } else {
      statusToSend = actionType;
    }

    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      origins: {
      principal_diagnosis: getOriginForCode(currentState?.principal?.[0]),
      additional_diagnoses: Object.fromEntries(
        (currentState?.additional || []).map(item => [
          item.code, 
          getOriginForCode(item)
        ])
      ),
      procedures: Object.fromEntries(
        (currentState?.procedure || []).map(item => [
          item.code, 
          getOriginForCode(item)
        ])
      )
    },
      module_name: moduleName,
      // queue_type:
      //   queueType === null
      //     ? null
      //     : (selectedQueueworkSpace?.queue_type ?? null),

      // queue_id:
      //   queueID === null ? null : (selectedQueueworkSpace?.queue_id ?? null),
      queue_type:
        queueType === null
          ? null
          : (queueType ?? selectedQueueworkSpace?.queue_type ?? null),
      queue_id:
        queueID === null
          ? null
          : (queueID ?? selectedQueueworkSpace?.queue_id ?? null),
      status: statusToSend, // Use the determined status
      request_from:
        currentPage === "coderview" || currentPage === "episodeList"
          ? "U"
          : currentPage === "auditorPage"
            ? "AU"
            : "",
      drg_code: [selectedDrgData?.drg],
      drg_weight: [selectedDrgData?.weight],
      line_assignment_id: Number(sessionStorage.getItem("lineAssignmentId")) || line_assignment_id || "",
      icu_hours:
        data1?.data?.meta?.icu_hours == null
          ? 0
          : Number(data1?.data?.meta.icu_hours),
      hmv_hours: Number.isNaN(parseInt(mvHours, 10))
        ? 0
        : parseInt(mvHours, 10),
      niv_hours: Number.isNaN(parseInt(nivHours, 10)) 
        ? 0 
        : parseInt(nivHours, 10),
      is_confirmed: false,
      grouper_versions: [drgSelectedVersion],
      cdq_request: cdqRequest ?? null,
      meta: {
        audit_queue_assignment: selectedQueueIds || [],
        assigned_user_id_for_review: [
          {
            auditor_for_review: auditorForReviewId ? [auditorForReviewId] : [],
            coder_for_review: coderForReviewId ? [coderForReviewId] : [],
            assignment_reason_for_review: reviewReason,
          },
        ],
        assigned_user_id_for_audit: [
          {
            auditors: resetQueue ? [] : selectedAuditorId || null,
            audit_queues: resetQueue ? [] : selectedAuditorQueueIds || [],
          },
        ],
        audit_queue_assignment: resetQueue ? [] : selectedQueueIds || [],
        missing_notes: [
          {
            reasons: reasons,
            additional_comments: comments,
          },
        ],
      },
    };
    //  console.log(payload,'szdxfcghjkjhjgh');
    if (actionsBtnDisable) return; 
    setActionsBtnDisable(true);
    try {
      const response = await acceptCode(payload);
      console.log(response.data?.updated_line_assignment_id,"respomse")
      if (response.status === 200) {
        toast.success("Action performed Successfully");
        setActionPerformed(true);
        isActionPerformed = true;
        sessionStorage.setItem("isConfirmed", true);
        console.log(response?.data?.updated_line_assignment_id,"jjjjjjjjjj")
         sessionStorage.setItem(
  "lineAssignmentId",
  String(response?.data?.updated_line_assignment_id)
);
        if (line_assignment_id) {
          sessionStorage.setItem(
            "lineAssignmentId",
            response?.data?.updated_line_assignment_id || lineAssignmentId,
          );
        }
        // if (line_assignment_id) {
        //   sessionStorage.setItem(
        //     "lineAssignmentId",
        //     response?.data?.updated_line_assignment_id || lineAssignmentId,
        //   );
        // }
      }else{
        setActionPerformed(false);
      }
    } catch (error) {
      // console.log(error);
      setActionPerformed(false);
      setActionsBtnDisable(false);
      const errorMessage =
        error?.response?.data?.message ||
        "Episode can't be assigned to Awaiting CDQ Response before episode is grouped";
      // console.log(error);
      toast.error(errorMessage);
    } finally {
      setSelectedQueueIds([]);
      setSelectedAuditorId(null);
      setSelectedCoderInActionId(null);
      setCoderForReviewId(null);
      setActionsBtnDisable(false);
      setAuditorForReviewId([]);
      setReviewReason("");
      dispatch(resetSelectedMissingNotesOptions());
      dispatch(setShowMissningNotesDropdown(false));
      dispatch(setEnableMissingNotes(false));
      setShowMyActionsDropdown(false);
      skipNextAutoDrgCalc.current = true;
      await fetchData1();
      await calculate_drg(isActionPerformed);
      setNewlyInsertedCodes([]);
      setDeletedCodes([]);
      setHasCofOrClusterChanged(false);
      setHasCodesSequenced(false);
      setAcceptedCodes({});
    }
  };
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("switchModule");
      toast.dismiss();
      sessionStorage.removeItem("isFromAccelerate");
      // if (fromAssist) {
      // sessionStorage.removeItem("newlyInsertedCodes");
      // }
    };
  }, []);
  return (
    <>
      <div style={{ height: "90%" }}>
        <ToastContainer autoClose={5000} />
        <div className="main-container" style={{ height: "100%" }}>
          <Box
            className="epsoide-status-card"
            sx={{
              maxHeight: {
                lg: "25%",
                md: "25%",
                sm: "30%",
                xs: "35%",
              },
            }}
          >
            <CodeContext.Provider
              value={{
                drgValue,
                setDrgValue,
                weightValue,
                drgValue,
                drgloading,
                reimbursementValue,
                isEpisodesLoading,
              }}
            >
              <EpisodeStatus
                drgData={drgData}
                setDrgData={setDrgData}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
                episodesFilterList={episodesFilterList}
                handleDrgInformation={handleDrgInformation}
                handleDRGOptions={handleDRGOptions}
                codingscreendata={data1}
                handleConfirmDrg={
                  codebookusaEnv ? handleConfirmDrgUSA : handleConfirmDrg
                }
                isDrgConfirmed={isDrgConfirmed}
                acceptedCodes={acceptedCodes}
                currentEpisode={currentEpisode}
                setCurrentEpisode={setCurrentEpisode}
                currentStatus={currentStatus}
                setCurrentStatus={setCurrentStatus}
                currentEpisodeNumber={currentEpisodeNumber}
                setCurrentEpisodeNumber={setCurrentEpisodeNumber}
                drgConfirmedStatusUpdate={drgConfirmedStatusUpdate}
                setOpenStatusUpdatedModal={setOpenStatusUpdatedModal}
                selectedCoderInActionId={selectedCoderInActionId}
                setSelectedCoderInActionId={setSelectedCoderInActionId}
                handleSendToAudit={handleSendToAudit}
                selectedQueueIds={selectedQueueIds}
                setSelectedQueueIds={setSelectedQueueIds}
                selectedAuditorQueueIds={selectedAuditorQueueIds}
                setSelectedAuditorQueueIds={setSelectedAuditorQueueIds}
                selectedAuditorId={selectedAuditorId}
                setSelectedAuditorId={setSelectedAuditorId}
                auditorForReviewId={auditorForReviewId}
                setAuditorForReviewId={setAuditorForReviewId}
                coderForReviewId={coderForReviewId}
                setCoderForReviewId={setCoderForReviewId}
                reviewReason={reviewReason}
                setReviewReason={setReviewReason}
                newlyInsertedCodes={newlyInsertedCodes}
                // selectedAuditorId={selectedAuditorId}
                // setSelectedAuditorId={setSelectedAuditorId}
                resetQueueFromNavigation={resetQueueFromNavigation}
                setOpenGenerateCDQ = {setOpenGenerateCDQ}
                setSendCDQ={setSendCDQ}
                diagnosisStates={diagnosisStates}
                deletedCodes={deletedCodes}
                setDeletedCodes={setDeletedCodes}
                hasDenyConfirmation={hasDenyConfirmation}
                isStatusUpdated={isStatusUpdated}
                selectedActionType={selectedActionType}
                setSelectedActionType={setSelectedActionType}
                setShowMyActionsDropdown={setShowMyActionsDropdown}
                showMyActionsDropdown={showMyActionsDropdown}
                hasCofOrClusterChanged={hasCofOrClusterChanged}
                hasCodesSequenced={hasCodesSequenced}
                setHasCofOrClusterChanged={setHasCofOrClusterChanged}
                setHasCodesSequenced={setHasCodesSequenced}
                setAcceptedCodes={setAcceptedCodes}
                stopcoderSessionTimeCalculated={stopcoderSessionTimeCalculated}
                actionsBtnDisable={actionsBtnDisable}
                 toggleCollapse={toggleCollapse}

              />
            </CodeContext.Provider>
          </Box>
          <Grid
            className="coding-container-section"
            sx={{
              mt: {
                lg: typeOfPatient !== "outPatient" ? 0 : 3,
                md: typeOfPatient !== "outPatient" ? 0 : 3,
                sm: typeOfPatient !== "outPatient" ? 2 : 3,
                xs: typeOfPatient !== "outPatient" ? 2 : 3,
              },
            }}
          >
            <Grid
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{
                width: "100%",
                display: {
                  xs: "block",
                  md: "block",
                  lg: "flex",
                },
              }}
            >
              {isLargeScreen ? (
                <>
                  <Card
                    variant="outlined"
                    sx={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    {!codeHistoryCard && showCodeSearch && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className=""
                          onClick={() => {
                            dispatch(setCodeHistoryCard(true));
                          }}
                        >
                          <span>CodingPathHistory</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                    {!codeAssistWindowCard && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className=""
                          onClick={() => {
                            dispatch(setCodeAssistWindowCard(true));
                          }}
                        >
                          <span>{buttonText}</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                    {!codeBookCard && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className=""
                          onClick={() => {
                            dispatch(setCodeBookCard(true));
                          }}
                        >
                          <span>CodeBook</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                  </Card>
                </>
              ) : (
                <Box
                  sx={{
                    my: {
                      sm: 1,
                      xs: 1,
                    },
                    // background: 'brown'
                  }}
                  className={`toggle-wrapper-side ${
                    !codeHistoryCard && !showCodeSearch
                      ? !codeBookCard || !codeAssistWindowCard
                        ? "active-card"
                        : ""
                      : !codeBookCard ||
                          !codeHistoryCard ||
                          !codeAssistWindowCard
                        ? "active-card"
                        : ""
                  }`}
                >
                  {!codeHistoryCard && showCodeSearch && (
                    <div className="cards-btn-container">
                      <button
                        className="cards-btn"
                        onClick={() => {
                          dispatch(setCodeHistoryCard(true));
                        }}
                      >
                        <span>CodingPathHistory</span>
                        <img
                          src={PlusIcon}
                          alt="plus"
                          className="cards-btn-img"
                        />
                      </button>
                    </div>
                  )}
                  {!codeAssistWindowCard && (
                    <div className="cards-btn-container">
                      <button
                        className="cards-btn"
                        onClick={() => {
                          dispatch(setCodeAssistWindowCard(true));
                        }}
                      >
                        <span>{buttonText}</span>
                        <img
                          src={PlusIcon}
                          alt="plus"
                          className="cards-btn-img"
                        />
                      </button>
                    </div>
                  )}
                  {!codeBookCard && (
                    <div className="cards-btn-container">
                      <button
                        className="cards-btn"
                        onClick={() => {
                          dispatch(setCodeBookCard(true));
                        }}
                      >
                        <span>CodeBook</span>
                        <img
                          src={PlusIcon}
                          alt="plus"
                          className="cards-btn-img"
                        />
                      </button>
                    </div>
                  )}
                </Box>
              )}
              {!showCodeSearch && nudgingCard && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  className="nudging-panel-card"
                  sx={{
                    width: {
                      lg:
                        nudgingCard && codeAssistWindowCard && codeBookCard
                          ? "28%" // matches codeHistoryCard's original share exactly
                          : !codeAssistWindowCard && !codeBookCard
                            ? "90%"
                            : "50%",
                      // no "0%" branch needed — this Grid only renders when nudgingCard is true
                    },
                  }}
                >
                  <NudgingCard onClose={() => dispatch(setNudgingCard(false))} diagnosisStates={diagnosisStates} acceptedCodes= {acceptedCodes} setDiagnosisStates={setDiagnosisStates} setAcceptedCodes={setAcceptedCodes} saveToHistory = {saveToHistory}/>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-screen-card"
                sx={{
                  width: {
                    lg: showCodeSearch
                      ? codeHistoryCard && codeAssistWindowCard && codeBookCard
                        ? "25%"
                        : !codeAssistWindowCard && !codeBookCard
                          ? "90%"
                          : !codeHistoryCard
                            ? "0%"
                            : "50%"
                      : "0%",
                  },
                  // height:
                  //   !codeAssistWindowCard && !codeBookCard ? "975px" : "auto",
                  display:
                    !showCodeSearch || !codeHistoryCard ? "none" : "flex",
                  justifyContent: showCodeSearch
                    ? codeHistoryCard && codeAssistWindowCard && codeBookCard
                      ? "space-between"
                      : "none"
                    : "none",
                  alignItems: showCodeSearch
                    ? codeHistoryCard && codeAssistWindowCard && codeBookCard
                      ? "start"
                      : "none"
                    : "none",
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">
                        Coding Path History
                      </p>
                      <span className="documentation-header-icon">
                        <img src={codinghistoryIcon} alt="history" />
                      </span>
                      <button
                        className="PrintHistory"
                        onClick={handleDownloadPdf}
                        disabled={!hasPrintableData}
                      >
                        Print
                      </button>
                    </div>
                    <button
                      className="documentation-section-close-icon"
                      onClick={() => toggleCollapse(1)}
                    >
                      <img src={closeIcon} alt="close" />
                    </button>
                  </div>
                  <div ref={printRef} className="print-area">
                    <CodeHistory />
                  </div>
                </div>
              </Grid>
              {/* <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-screen-card"
                sx={{
                  width: {
                    lg: documentationCard ? "40%" : "0%", // Adjust width as needed
                  },
                  display: documentationCard ? "flex" : "none",
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">Documentation</p>
                      <span className="documentation-header-icon">
                        <img src={documentationIcon} alt="doc" />
                      </span>
                    </div>
                    <div className="documentation-header-right-side">
                      {(codebookdevEnv ||
                        codebookusaEnv ||
                        codebookinternalEnv) &&
                        (permissionList?.includes("admin") ||
                          permissionList?.includes("Code Accelerate") ||
                          permissionList?.includes("Code Assist")) && (
                          <Tooltip title="Upload your own documents">
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#0d3b66",
                                mr: 1,
                                borderRadius: "10px",
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                              }}
                              onClick={() => navigate("/upload-document")}
                            >
                              <UploadFileIcon style={{ height: "15px" }} />
                            </Button>
                          </Tooltip>
                        )}
                      <button
                        className="documentation-section-close-icon"
                        onClick={() => toggleCollapse(4)} // Use 4 for documentation
                      >
                        <img src={closeIcon} alt="close" />
                      </button>
                    </div>
                  </div>
                  <DocumentViewer episodeList={episodeList} />
                </div>
              </Grid> */}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-screen-card card"
                sx={{
                  /* Change 1: Updated width to 70% when showCodeSearch is false and codeBookCard is true, matching the showCodeSearch true case */
                  width: {
                    lg: showCodeSearch
                      ? !codeBookCard
                        ? "95%"
                        : !codeHistoryCard
                          ? "70%"
                          : "48%"
                      : !codeBookCard
                        ? "95%"
                           : nudgingCard
                        ? "45%"         
                        : "70%",   
                        
                  },
                  display: !codeAssistWindowCard ? "none" : "flex",
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">{headerText}</p>
                      <span className="documentation-header-icon">
                        <img src={codeassistIocn} alt="assist" />
                      </span>
                    </div>
                    <div className="d-flex gap-2">
                      <Tooltip title="Undo your last action">
                        <button
                          disabled={trackHistory?.length === 0}
                          onClick={handleUndo}
                          className="undo-button"
                        >
                          <img
                            className="undo-icon"
                            src={undo_icon}
                            alt="undo"
                          />
                        </button>
                      </Tooltip>
                      <Tooltip title="Redo your last action">
                        <button
                          onClick={handleRedo}
                          disabled={redoStack?.length === 0}
                          className="redo-button"
                        >
                          <img
                            className="redo_icon"
                            src={undo_icon}
                            alt="redo"
                          />
                        </button>
                      </Tooltip>
                      <button
                        className="documentation-section-close-icon"
                        onClick={() => toggleCollapse(2)}
                      >
                        <img src={closeIcon} alt="close" />
                      </button>
                    </div>
                  </div>
                  {isLoadingCodingScreen && !isFromAccelerate ? (
                    <LdsRoller />
                  ) : (
                    <CodeContext.Provider
                      value={{
                        drgValue,
                        weightValue,
                        setCodeBookCard,
                        episodeList,
                        setDrgValue,
                        setweightValue,
                        setDrgLoading,
                        setReimbursementValue,
                        data1,
                        isLoadingCodingScreen,
                        setAccepted,
                        diagnosisStates,
                        setDiagnosisStates,
                        setTrackHistory,
                        setRedoStack,
                        selectedCodeBookCode,
                        setSelectedCodeBookCode,
                        selectedTabKeyCoding,
                        setSelectedTabKeyCoding,
                        calculate_drg,
                        handleConfirmDrg,
                        handleConfirmDrgUSA,
                        isDrgConfirmed,
                      }}
                    >
                      <>
                        <div
                          style={{
                            display: codeAssistWindowCard ? "flex" : "none",
                            height: "100%",
                            flexDirection: "column",
                          }}
                        >
                          <CodeAssistWindow
                            showCodeSearch={showCodeSearch}
                            setShowCodeSearch={setShowCodeSearch}
                            setHeaderText={setHeaderText}
                            setButtonText={setButtonText}
                            isFetchingData1={isFetchingData1}
                            setIsFetchingData1={setIsFetchingData1}
                            acceptedCodes={acceptedCodes}
                            setAcceptedCodes={setAcceptedCodes}
                            isDrgConfirmed={isDrgConfirmed}
                            setEnableFinalize={setEnableFinalize}
                            enableFinalize={enableFinalize}
                            auditedStatus={auditedStatus}
                            isCheckingWarnings={isCheckingWarnings}
                            setAuditedStatus={setAuditedStatus}
                            handleCodeAssistAdding={
                              codebookusaEnv
                                ? handleCodeAssistAddingUSA
                                : handleCodeAssistAdding
                            }
                            validateCodeAPI={validateCodeAPI}
                            insertCode={insertCode}
                            // handleAccept={handleAccept}
                            iconDisplay={iconDisplay}
                            setIconDispaly={setIconDispaly}
                            saveToHistory={saveToHistory}
                            warningMessage={warningMessage}
                            setWarningMessage={setWarningMessage}
                            newlyInsertedCodes={newlyInsertedCodes}
                            setNewlyInsertedCodes={setNewlyInsertedCodes}
                            pendingCode={pendingCode}
                            setPendingCode={setPendingCode}
                            pendingType={pendingType}
                            setPendingType={setPendingType}
                            modalVisible={modalVisible}
                            setModalVisible={setModalVisible}
                            modalMessage={modalMessage}
                            setModalMessage={setModalMessage}
                            activeIcon={activeIcon}
                            setActiveIcon={setActiveIcon}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            skipAcceptApi={skipAcceptApi}
                            nextClusterCurrentIndex={nextClusterCurrentIndex}
                            mvHours={mvHours}
                            setMvHours={setMvHours}
                            nivHours={nivHours}
                            setNivHours={setNivHours}
                            handleMvhoursupdation={handleMvhoursupdation}
                            deletedCodes={deletedCodes}
                            setDeletedCodes={setDeletedCodes}
                            triggerWarnings={triggerWarnings}
                            hasDenyConfirmation={hasDenyConfirmation}
                            selectedActionType={selectedActionType}
                            setSelectedActionType={setSelectedActionType}
                            isBatchInsertingRef={isBatchInsertingRef}
                            batchInsertCompleted={batchInsertCompleted}
                            setBatchInsertCompleted={setBatchInsertCompleted}
                            hasCofOrClusterChanged={hasCofOrClusterChanged}
                            setHasCofOrClusterChanged={setHasCofOrClusterChanged}
                            setShowMyActionsDropdown={setShowMyActionsDropdown}
                            hasCodesSequenced={hasCodesSequenced}
                            setHasCodesSequenced={setHasCodesSequenced}
                            diagnosisStates={diagnosisStates}
                            setActionPerformed={setActionPerformed}
                            skipNextAutoDrgCalc={skipNextAutoDrgCalc}
                            trackingIntervalRef={trackingIntervalRef}
                            waitForUserActionRef={waitForUserActionRef}
                            stopcoderSessionTimeCalculated={stopcoderSessionTimeCalculated}
                            hasUnsavedChanges={hasUnsavedChanges}
                            fetchNudgingData={fetchNudgingData}
                          />
                        </div>

                        {!codeAssistWindowCard &&
                          (codebookusaEnv ? (
                            <CodeSearchUSA
                              codePathHistory={codePathHistory}
                              setIsFetchingData1={setIsFetchingData1}
                              activeIcon={activeIcon}
                              setActiveIcon={setActiveIcon}
                              activeTab={activeTab}
                              setActiveTab={setActiveTab}
                            />
                          ) : (
                            <CodeSearch
                              codePathHistory={codePathHistory}
                              setIsFetchingData1={setIsFetchingData1}
                              activeIcon={activeIcon}
                              setActiveIcon={setActiveIcon}
                              activeTab={activeTab}
                              setActiveTab={setActiveTab}
                            />
                          ))}
                      </>
                    </CodeContext.Provider>
                  )}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-book-card"
                sx={{
                  /* Change 2: Updated width to 30% when showCodeSearch is false and codeAssistWindowCard is true, matching the showCodeSearch true case */
                  width: {
                    lg: showCodeSearch
                      ? codeAssistWindowCard
                        ? !codeHistoryCard
                          ? "30%"
                          : "25%"
                        : "95%"
                      : codeAssistWindowCard
                       ? nudgingCard
                        ? "30%"
                        :"30%"
                        : "95%",
                  },
                  height: "100%",

                  display: !codeBookCard ? "none" : "flex",
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">Codebook</p>
                      <span className="documentation-header-icon">
                        <img src={codeBookIcon} alt="codebook" />
                      </span>
                    </div>
                    <button
                      className="documentation-section-close-icon"
                      onClick={() => toggleCollapse(3)}
                    >
                      <img src={closeIcon} alt="close" />
                    </button>
                  </div>
                  <CodeContext.Provider
                    value={{
                      selectedCodeBookCode,
                      setSelectedCodeBookCode,
                      selectedTabKeyCoding,
                      setSelectedTabKeyCoding,
                      copiedCodes,
                      setCopiedCodes,
                    }}
                  >
                    {codebookusaEnv && (
                      <CodeBookUsa
                        activeIcon={activeIcon}
                        setActiveIcon={setActiveIcon}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                      />
                    )}
                    {(codebookdevEnv ||
                      codebookinternalEnv ||
                      codebookcoblhEnv ||
                      codebooknmhsEnv ||
                      codebooksanEnv ||
                      codebooksanprodEnv ||
                      pallasaiTestCodebookEnv ||
                      codebookhealthecareEnv||
                      codebooksanhcEnv ||
                      codebookfigiEnv) && (
                      <CodeBookDev
                        dischargeDate={separationDate}
                        activeIcon={activeIcon}
                        setActiveIcon={setActiveIcon}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        isLockedCoder={isLockedCoder}
                      />
                    )}
                  </CodeContext.Provider>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {drgModalVisible && (
          <div class="modal-overlay drg-modal">
            <div className="modal-overlay">
              <div className="drg-options-modal-content">
                <div class="modal-header">
                  <Typography
                    variant="h2"
                    sx={
                      {
                        // background: {
                        //   md: "brown",
                        //   sm: 'yellow',
                        //   xs: "blue"
                        // }
                      }
                    }
                  >
                    Grouping Options
                  </Typography>
                  <button class="close-button">&times;</button>
                </div>
                <Typography
                  className="modal-subtitle"
                  sx={{
                    fontSize: {
                      sm: "14px",
                      xs: "12px",
                    },
                  }}
                >
                  Select new principal diagnosis, if applicable
                </Typography>
                {drgOptionsLoading ? (
                  <Box
                    sx={{
                      height: {
                        lg: "auto",
                        md: "auto",
                        sm: "300px",
                        xs: "300px",
                      },
                      textAlign: "center",
                    }}
                  >
                    <LdsRoller />
                  </Box>
                ) : (
                  <>
                    {isMediumScreen ? (
                      <Box
                        sx={{
                          // background: "brown",
                          maxHeight: "300px",
                          overflow: "auto",
                          width: "auto",
                          borderRadius: "5px",
                        }}
                      >
                        {allDRGCodesTableData?.map((item, index) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              margin: "10px",
                              backgroundColor:
                                selectedRowIndex === index ? "#e6f7ff" : "fff",
                              padding: "10px",
                              borderRadius: "5px",
                              border: "1px solid #cdcdcd",
                            }}
                            onClick={() => setSelectedRowIndex(index)}
                          >
                            <Typography sx={{ fontSize: "12px" }}>
                              PDX-{" "}
                              {item?.principal_diagnosis
                                ?.replace(/[.\-']/g, "")
                                ?.replace(/\s*\[.*?\]\s*/g, "")
                                ?.slice(1)}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              PPX.2{" "}
                              {item?.procedure_codes === null ? (
                                <span>No procedure codes</span>
                              ) : (
                                <span>
                                  {Array.isArray(item?.procedure_codes)
                                    ? item.procedure_codes.length === 0
                                      ? "No procedure codes"
                                      : item.procedure_codes
                                          ?.join(", ")
                                          ?.replace(/[.\-']/g, "")
                                          ?.replace(/\s*\[.*?\]\s*/g, "")
                                    : item?.procedure_codes?.trim()
                                      ? item.procedure_codes
                                          ?.replace(/[.\-']/g, "")
                                          ?.replace(/\s*\[.*?\]\s*/g, "")
                                      : "No procedure codes"}
                                </span>
                              )}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              DRG: {item?.drg_code}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              weight:{" "}
                              {item?.weight === "can't determine"
                                ? "-"
                                : Number(item?.weight).toFixed(4)}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              ALOS -{item?.alos ?? "-"}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              REIMB $ -{" "}
                              {codebookusaEnv
                                ? Math.round(
                                    item?.reimbursement ?? 0,
                                  ).toLocaleString()
                                : item?.weight === "can't determine"
                                  ? "-"
                                  : Math.round(
                                      item.weight * 7258,
                                    ).toLocaleString()}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              PDX DESCRIPTION -{item?.description}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <div className="grouping-table-wrapper">
                        <table className="grouping-table">
                          <thead>
                            <tr>
                              <th>PDX</th>
                              <th>PPX.2</th>
                              <th>DRG</th>
                              <th>WEIGHT</th>
                              <th>ALOS</th>
                              <th>REIMB $</th>
                              <th>PDX DESCRIPTION</th>
                            </tr>
                          </thead>
                        </table>
                        <div className="table-body-scroll">
                          <table className="grouping-table">
                            <tbody>
                              {allDRGCodesTableData?.map((item, index) => (
                                <tr
                                  key={index}
                                  onClick={() => setSelectedRowIndex(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? "selected-row"
                                      : ""
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <td>
                                    {item?.principal_diagnosis
                                      .replace(/[.\-']/g, "")
                                      .replace(/\s*\[.*?\]\s*/g, "")
                                      .slice(1)}
                                  </td>
                                  <td>
                                    {item.procedure_codes === null ? (
                                      <span>No procedure codes</span>
                                    ) : (
                                      <span>
                                        {Array.isArray(item?.procedure_codes)
                                          ? item.procedure_codes.length === 0
                                            ? "No procedure codes"
                                            : item.procedure_codes
                                                .join(", ")
                                                .replace(/[.\-']/g, "")
                                                .replace(/\s*\[.*?\]\s*/g, "")
                                          : item?.procedure_codes?.trim()
                                            ? item.procedure_codes
                                                .replace(/[.\-']/g, "")
                                                .replace(/\s*\[.*?\]\s*/g, "")
                                            : "No procedure codes"}
                                      </span>
                                    )}
                                  </td>
                                  <td>{item?.drg_code}</td>
                                  <td>
                                    {item?.weight === "can't determine"
                                      ? "-"
                                      : Number(item?.weight).toFixed(4)}
                                  </td>
                                  <td>{item?.alos ?? "-"}</td>
                                  <td>
                                    {codebookusaEnv
                                      ? Math.round(
                                          item?.reimbursement ?? 0,
                                        ).toLocaleString()
                                      : item?.weight === "can't determine"
                                        ? "-"
                                        : Math.round(
                                            item.weight * 7258,
                                          ).toLocaleString()}
                                  </td>
                                  <Tooltip title={item.description}>
                                    <td>{item?.description}</td>
                                  </Tooltip>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div class="modal-actions">
                  <button
                    class="cancel-button"
                    onClick={() => setDrgModalVisible(false)}
                  >
                    Cancel
                  </button>
                  <button class="ok-button" onClick={handleOkClick}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {clusterCodeWarningsWarningList && clusterCodeWarningsWarningList?.warnings > 0 || clusterCodeWarningsWarningList && clusterCodeWarningsWarningList?.errors?.length > 0 && ( */}
        <WarningPanel
          show={warningModal}
          clusterCodeWarningsList={clusterCodeWarningsList?.warnings}
          clusterCodeWarningsErrorList={clusterCodeWarningsList?.errors}
          onClose={() => {
            setWarningModal(false);
            dispatch(setClusterCodeWarningsList([]));
          }}
        />
        <CancerWarningPanel
          show={cancerWarningModal}
          cancerCodeWarningsList={cancerCodeWarningsList}
          // clusterCodeWarningsErrorList={clusterCodeWarningsList?.errors}
          onClose={() => {
            setCancerWarningModal(false);
            dispatch(setCancerCodeWarningsList([]));
          }}
        />
        {/* )} */}
        {isCalculatingDrg && (
          <div className="episodeStatus-him-assign-modal-overlay-fade">
            <div className="episodeStatus-him-assign-modal-container">
              <div
                className="episodeStatus-him-assign-header"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "24px",
                  gap: "16px",
                  textAlign: "center",
                }}
              >
                <CircularProgress size={45} thickness={4} />

                <p className="episodeStatus-him-assign-header-text">
                  <span>
                    Calculating DRG information. Please wait approximately 30
                    seconds.
                  </span>
                </p>

                <div className="episode-status-redirect-container"></div>
              </div>
            </div>
          </div>
        )}
      </div>
      {blocker.state === "blocked" && (
        <div className="episodeStatus-him-assign-modal-overlay-fade">
          <div className="episodeStatus-him-assign-modal-container">
            <div
              className="episodeStatus-him-assign-header"
              style={{ padding: "24px", textAlign: "center" }}
            >
              <p className="episodeStatus-him-assign-header-text">
                Unsaved changes detected. Please confirm the DRG before leaving, or your changes will be lost.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  marginTop: "16px",
                }}
              >
                <button
                  className="navigation-cancel-button"
                  onClick={() => {
                     blocker.reset()
                  }}
                >
                  Stay
                </button>
                <button
                  className="ok-button"
                  onClick={() => {
                    // Clear sessionStorage directly — states won't be accessible after navigation
                    sessionStorage.setItem(
                      "newlyInsertedCodes",
                      JSON.stringify([]),
                    );
                    sessionStorage.setItem("deletedCodes", JSON.stringify([]));
                    sessionStorage.setItem(
                      "hasCofOrClusterChanged",
                      JSON.stringify(false),
                    );
                    sessionStorage.setItem(
                      "hasCodesSequenced",
                      JSON.stringify(false),
                    );
                    sessionStorage.setItem("acceptedCodes", JSON.stringify({}));
                    if(isSessionStarted){
                      // stopcoderSessionTimeCalculated()
                    }
                    const nudgingSessionPayload = {
                          hcp_line_id: lastHcpLineId,
                          is_confirmed: true,
                          session_token:nudgingSessionResponseData?.data?.nudging_session_token ,
                        };
                        const nudgingSessionAPIResponse = dispatch(
                          nudgingSessionAPI(nudgingSessionPayload),
                        ).then(()=>{
                            sessionStorage.removeItem("nudging_session_id");
                            sessionStorage.removeItem("nudging_session_token");
                        })
                         
                    blocker.proceed();
                  }}
                >
                  Leave
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {(codebookcoblhEnv||codebookdevEnv)&&(<GenerateCDQ open={openGenerateCDQ} onClose={() => {
             
              setOpenGenerateCDQ(false);
              
            }} onCdqSend={() => {
          setOpenGenerateCDQ(false);
          setSendCDQ(true);
        }} 
        isSendingCDQ={isSendingCDQ}
        episodeList = {episodeList}/>)}
    </>
  );
};

export default CodeAssistWrapper;
